<template>
  <v-container
    class="twilio-whatsapp-shell textoPoppins pa-0"
    fluid
    @keydown.ctrl="abrirPegar"
    v-if="getEscuela == 1 || accesos.includes(getdatosUsuarioERPERP.iderp)"
  >
    <v-card class="twilio-whatsapp-app elevation-6">
      <v-row class="ma-0 fill-height twilio-whatsapp-row">
        <v-col
          cols="12"
          sm="6"
          class="pa-0 twilio-whatsapp-sidebar"
          :class="{ 'wa-panel-hidden': isMobileLayout && chat }"
        >
          <Toolbar
            :whatsapp-style="true"
            :nameTwilio="'TWILIO UNIFICADO'"
            :vendedorasTwilio="vendedorasTwilio"
            :filtroVendedora="filtroVendedora"
            :vendedoras_plantel="vendedoras_plantel"
            :conteoTiempoVendedores="conteoTiempoVendedores"
            :cantidadChats="filterChats.length"
            :tiempoCargaMs="tiempoCargaMs"
            :mostrarDescargarConversaciones="puedeAccionesSusanaUnificado"
            :exportandoUltimasConversaciones="exportandoUltimasConversaciones"
            :puedeReasignarMasivo="puedeReasignarMasivo"
            :cantidadSeleccionados="chatsSeleccionados.length"
            @seleccionaVendedora="seleccionaVendedora"
            @initialize="initializeAllCities()"
            @abrirAjustesMensajes="abrirAjustesMensajes"
            @emitUsersChats="getUsersChats()"
            @emitOnlyMychats="seleccionaVendedora()"
            @descargar-ultimas-conversaciones="descargarTodasConversaciones"
            @reasignar-masivo="abrirReasignacionMasiva"
            :alumnos="alumnos"
            :planteles="[]"
            :filterChats="chatsHoraEncargadas"
          />

          <div class="wa-search-panel">
            <v-text-field
              :readonly="filterChats ? false : true"
              v-model="buscarUsuario"
              hide-details
              dense
              solo
              flat
              clearable
              rounded
              :autofocus="buscarUsuarioActive"
              prepend-inner-icon="mdi-magnify"
              placeholder="Buscar o iniciar un chat"
              class="wa-search"
              @input="programarValidacionBusquedaCerrado"
              @keyup.enter="validarBusquedaCerradoEnBd(buscarUsuario)"
              @click:clear="avisoBusquedaCerrado = null"
            ></v-text-field>

            <v-alert
              v-if="avisoBusquedaCerrado"
              dense
              text
              colored-border
              border="left"
              type="warning"
              dismissible
              class="mt-2 mb-1"
              @input="avisoBusquedaCerrado = null"
            >
              <span class="font-weight-bold">{{ avisoBusquedaCerrado }}</span>
            </v-alert>

            <v-progress-linear
              v-if="cargandoBusquedaCerrado"
              indeterminate
              color="#00a884"
              height="2"
              class="mx-2"
            ></v-progress-linear>

            <div class="wa-filter-row wa-filter-row--stacked">
              <v-select
                v-if="accesosBoton"
                class="wa-select wa-incompletos-select"
                dense
                hide-details
                solo
                flat
                rounded
                :items="opcionesIncompletos"
                label="Incompletos"
                v-model="filtroIncompletos"
                item-value="value"
                item-text="text"
                clearable
              ></v-select>

              <v-select
                class="wa-select wa-incompletos-select"
                dense
                hide-details
                solo
                flat
                rounded
                :items="ciudades"
                label="Ciudad"
                v-model="filtroCiudad"
                item-value="value"
                item-text="text"
              ></v-select>
            </div>

            <div
              v-if="puedeGestionarSusanaConfig"
              class="wa-filter-row align-center px-2 mb-1"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    :color="susanaTodosActivo ? 'error' : 'success'"
                    :loading="cargandoSusanaConfig"
                    @click="toggleTodosASusana"
                  >
                    <v-icon>{{ susanaTodosActivo ? 'mdi-robot-off' : 'mdi-robot' }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ susanaTodosActivo ? 'Detener a Susana (nuevos → bot)' : 'Activar Susana (nuevos → agente)' }}</span>
              </v-tooltip>
              <span class="text-caption ml-1" :style="{ color: susanaTodosActivo ? '#2e7d32' : '#757575' }">
                {{ susanaTodosActivo ? 'Susana ON' : 'Susana OFF' }}
              </span>
            </div>

            <div class="wa-filter-row">
              <v-btn
                small
                :depressed="filtroFuego"
                class="wa-filter-btn"
                :class="{ 'px-3': true }"
                :fab="!filtroFuego"
                :rounded="filtroFuego"
                :color="filtroFuego ? 'red' : 'white'"
                :dark="filtroFuego"
                @click="activarFiltroFuego"
              >
                <span class="text-h6" :class="{ 'mr-1': filtroFuego }">🔥</span>
                <span v-if="filtroFuego" class="text-caption font-weight-bold">Fuego</span>
              </v-btn>

              <v-btn
                small
                :depressed="filtroHielo"
                class="wa-filter-btn"
                :class="{ 'px-3': true }"
                :fab="!filtroHielo"
                :rounded="filtroHielo"
                :color="filtroHielo ? 'blue' : 'white'"
                :dark="filtroHielo"
                @click="activarFiltroHielo"
              >
                <span class="text-h6" :class="{ 'mr-1': filtroHielo }">🧊</span>
                <span v-if="filtroHielo" class="text-caption font-weight-bold">Hielo</span>
              </v-btn>

              <v-btn
                small
                :depressed="filtroRecomendados"
                class="wa-filter-btn"
                :class="{ 'px-3': true }"
                :fab="!filtroRecomendados"
                :rounded="filtroRecomendados"
                :color="filtroRecomendados ? 'deep-purple' : 'white'"
                :dark="filtroRecomendados"
                @click="activarFiltroRecomendados"
              >
                <v-icon :color="filtroRecomendados ? 'white' : 'deep-purple'" left v-if="filtroRecomendados" x-small>mdi-account-multiple-plus</v-icon>
                <span v-if="filtroRecomendados" class="text-caption font-weight-bold">rec</span>
                <span v-else class="text-caption font-weight-bold purple--text text--darken-2">rec</span>
              </v-btn>

              <v-tooltip bottom color="blue" max-width="280">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="filtroCartera"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!filtroCartera"
                    :rounded="filtroCartera"
                    :color="filtroCartera ? 'amber darken-2' : 'white'"
                    :dark="filtroCartera"
                    v-bind="attrs"
                    v-on="on"
                    @click="activarFiltroCartera"
                  >
                    <v-icon :color="filtroCartera ? 'white' : 'amber darken-2'" left v-if="filtroCartera">mdi-wallet</v-icon>
                    <v-icon :color="filtroCartera ? 'white' : 'amber darken-2'" v-else>mdi-wallet</v-icon>
                    <span v-if="filtroCartera" class="text-caption font-weight-bold">Cartera</span>
                  </v-btn>
                </template>
                <span>Asignación de cartera (solo etiquetados). Clic de nuevo para quitar.</span>
              </v-tooltip>

              <v-btn
                small
                :depressed="filtroMensajes"
                class="wa-filter-btn"
                :class="{ 'px-3': true }"
                :fab="!filtroMensajes"
                :rounded="filtroMensajes"
                :color="filtroMensajes ? 'red' : 'white'"
                :dark="filtroMensajes"
                @click="activarFiltroMensajes"
              >
                <v-icon :color="filtroMensajes ? 'white' : 'red'" left v-if="filtroMensajes">mdi-message-badge</v-icon>
                <v-icon :color="filtroMensajes ? 'white' : 'red'" v-else>mdi-message-badge</v-icon>
                <span v-if="filtroMensajes" class="text-caption font-weight-bold">4+ msgs</span>
              </v-btn>

              <v-tooltip v-if="puedeVerFiltroFinalizo" bottom max-width="260">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="filtroFinalizo"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!filtroFinalizo"
                    :rounded="filtroFinalizo"
                    :color="filtroFinalizo ? 'teal darken-1' : 'white'"
                    :dark="filtroFinalizo"
                    v-bind="attrs"
                    v-on="on"
                    @click="activarFiltroFinalizo"
                  >
                    <v-icon :color="filtroFinalizo ? 'white' : 'teal darken-1'" left v-if="filtroFinalizo">mdi-file-check-outline</v-icon>
                    <v-icon :color="filtroFinalizo ? 'white' : 'teal darken-1'" v-else>mdi-file-check-outline</v-icon>
                    <span v-if="filtroFinalizo" class="text-caption font-weight-bold">Finalizó</span>
                  </v-btn>
                </template>
                <span>Solo chats cuyo historial tiene el mensaje de ficha (pre-registro / *Nombre:*…). Clic de nuevo para quitar.</span>
              </v-tooltip>

              <v-tooltip v-if="puedeVerFiltroAgenteIA" bottom max-width="260">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="filtroAgenteIA"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!filtroAgenteIA"
                    :rounded="filtroAgenteIA"
                    :color="filtroAgenteIA ? 'deep-purple' : 'white'"
                    :dark="filtroAgenteIA"
                    v-bind="attrs"
                    v-on="on"
                    @click="activarFiltroAgenteIA"
                  >
                    <v-icon :color="filtroAgenteIA ? 'white' : 'deep-purple'" left v-if="filtroAgenteIA">mdi-robot</v-icon>
                    <v-icon :color="filtroAgenteIA ? 'white' : 'deep-purple'" v-else>mdi-robot</v-icon>
                    <span v-if="filtroAgenteIA" class="text-caption font-weight-bold">Agente IA</span>
                  </v-btn>
                </template>
                <span>Solo chats que entraron por Agente IA (chip IA). Clic de nuevo para quitar.</span>
              </v-tooltip>

              <v-btn
                rounded
                class="wa-filter-clear"
                @click="limpiarFiltrosLista"
              >
                Todos!!
              </v-btn>

              <v-btn
                small
                :depressed="filtroVistos"
                class="wa-filter-btn"
                :class="{ 'px-3': true }"
                :fab="!filtroVistos"
                :rounded="filtroVistos"
                :color="filtroVistos ? 'grey darken-2' : 'white'"
                :dark="filtroVistos"
                @click="filtroVistos = !filtroVistos"
              >
                <v-icon :color="filtroVistos ? 'white' : 'grey darken-2'" left v-if="filtroVistos">mdi-message-bulleted-off</v-icon>
                <v-icon :color="filtroVistos ? 'white' : 'grey darken-2'" v-else>mdi-message-bulleted-off</v-icon>
                <span v-if="filtroVistos" class="text-caption font-weight-bold">Sin responder</span>
              </v-btn>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="!!etiqueta"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!etiqueta"
                    :rounded="!!etiqueta"
                    :color="etiqueta ? (etiqueta.color || 'grey darken-2') : 'white'"
                    :dark="!!etiqueta"
                    v-bind="attrs"
                    v-on="etiqueta ? {} : on"
                    @click="onClickBotonEtiqueta"
                  >
                    <v-icon :color="etiqueta ? 'white' : 'grey darken-2'" left v-if="etiqueta">mdi-label</v-icon>
                    <v-icon :color="etiqueta ? 'white' : 'grey darken-2'" v-else>mdi-checkbox-blank-circle</v-icon>
                    <span v-if="etiqueta" class="text-caption font-weight-bold">{{ etiqueta.text }}</span>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item v-for="(item, index) in etiquetas" :key="index" @click="seleccionarEtiqueta(item)">
                    <v-list-item-title class="text-caption">
                      <v-icon small :color="item.color">mdi-label</v-icon>
                      {{ item.text }} {{ item.count ? '(' + item.count + ')' : '' }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="!!filtroTiempo"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!filtroTiempo"
                    :rounded="!!filtroTiempo"
                    :color="filtroTiempo ? (filtroTiempo.color || 'grey darken-2') : 'white'"
                    :dark="!!filtroTiempo"
                    v-bind="attrs"
                    v-on="filtroTiempo ? {} : on"
                    @click="onClickBotonTiempo"
                  >
                    <v-icon :color="filtroTiempo ? 'white' : 'grey darken-2'" left v-if="filtroTiempo">mdi-clock</v-icon>
                    <v-icon :color="filtroTiempo ? 'white' : 'grey darken-2'" v-else>mdi-clock</v-icon>
                    <span v-if="filtroTiempo" class="text-caption font-weight-bold">{{ filtroTiempo.text }}</span>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item v-for="(item, index) in tiempos" :key="index" @click="seleccionarFiltroTiempo(item)">
                    <v-list-item-title class="text-caption">
                      <v-icon small :color="item.color">mdi-clock</v-icon>
                      {{ item.text }} {{ item.count != null ? '(' + item.count + ')' : '' }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>

          <ListaContactos
            :filterChats="filterChats"
            :whatsapp-style="true"
            :chat-activo="chat"
            :mostrar-marca-ia-susana="puedeVerMarcaIaSusana"
            :permitir-seleccion="puedeReasignarMasivo"
            :seleccionados.sync="chatsSeleccionados"
            @verChat="verChat"
            :limite="limite"
            @cargar-mas="onCargarMasChats"
          />
        </v-col>

        <v-col
          cols="12"
          sm="6"
          class="pa-0 twilio-whatsapp-conversation"
          :class="{ 'wa-panel-hidden': isMobileLayout && !chat }"
        >

          <div v-if="!chat" class="wa-empty-state">
            <v-icon size="96" color="#d1d7db">mdi-whatsapp</v-icon>
            <h2>WhatsApp CRM</h2>
            <p>Selecciona un chat para ver la conversación en tiempo real.</p>
          </div>

          <template v-else>
            <div class="wa-chat-header">
              <div class="wa-chat-header-left">
                <v-btn
                  v-if="isMobileLayout"
                  icon
                  small
                  class="wa-back-btn"
                  @click="cerrarChatMobile"
                >
                  <v-icon color="#54656f">mdi-arrow-left</v-icon>
                </v-btn>
                <v-avatar :color="!chat.nombre ? '#00a884' : '#dfe5e7'" size="40" class="wa-chat-avatar">
                  <v-icon color="white" v-if="!chat.nombre">mdi-account</v-icon>
                  <span v-else class="wa-avatar-text">{{ chat.nombre }}</span>
                </v-avatar>
                <div class="wa-chat-header-info">
                  <div class="wa-chat-name">{{ chat.nombre_completo || chat.usuario }}</div>
                  <div class="wa-chat-meta" v-if="chat.nombre_completo && chat.usuario">{{ chat.usuario }}</div>
                  <div class="wa-chat-meta" v-if="chat.folio">Folio {{ chat.folio }}</div>
                  <div
                    class="wa-chat-meta"
                    v-if="preguntasEvaluacion.length > 0 && preguntasEvaluacion[0].score && [568, 1, 334, 3015, 2354].includes(getdatosUsuarioERPERP.iderp)"
                  >
                    Score: {{ preguntasEvaluacion[0].score }}
                  </div>
                  <div class="wa-chat-timing" v-if="tiempoCargaChatMs != null">
                    twilio.chats.unico · {{ tiempoCargaChatMs }} ms
                  </div>
                </div>
              </div>

              <div class="wa-chat-actions">
                <v-tooltip
                  v-if="[568, 1, 334, 3015, 2354].includes(getdatosUsuarioERPERP.iderp) && preguntasEvaluacion.length > 0 && preguntasEvaluacion[0].score"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      :disabled="!chat.idprospectos || !chat.usuario_asignado"
                      @click="abrirDialogEvaluacion"
                    >
                      <v-icon color="#54656f">{{ preguntasEvaluacion[0].score ? 'mdi-pencil' : 'mdi-check-circle' }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ preguntasEvaluacion[0].score ? 'Editar evaluación' : 'Evaluar' }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="[1, 3, 568, 334, 3015, 2268, 2155, 2472, 2556, 1312, 2767, 2910].includes(getdatosUsuarioERPERP.iderp) && chat.folio"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      @click="abrirReasignacionIndividual"
                    >
                      <v-icon color="#54656f">mdi-account-switch</v-icon>
                    </v-btn>
                  </template>
                  <span>Reasignar</span>
                </v-tooltip>

                <!-- Reiniciar CTX + Borrar chat → un solo icono con menú -->
                <v-menu
                  v-if="puedeAccionesSusanaUnificado"
                  bottom
                  offset-y
                  :close-on-content-click="true"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      :loading="limpiandoAgente"
                      :disabled="limpiandoAgente"
                      title="Limpiar contexto / borrar chat"
                    >
                      <v-icon color="#54656f">mdi-broom</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item @click="abrirDialogReiniciarContexto">
                      <v-list-item-icon class="mr-2">
                        <v-icon small>mdi-restore</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="text-caption">Reiniciar CTX</v-list-item-title>
                        <v-list-item-subtitle class="text-caption">Conserva mensajes</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="abrirDialogBorrarConversacion">
                      <v-list-item-icon class="mr-2">
                        <v-icon small color="error">mdi-delete-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="text-caption error--text">Borrar chat</v-list-item-title>
                        <v-list-item-subtitle class="text-caption">Borra mensajes y contexto</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tooltip
                  v-if="puedeAccionesSusanaUnificado && chat && chat.usuario"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      :loading="bloqueandoNumero"
                      :disabled="bloqueandoNumero || limpiandoAgente"
                      @click="bloquearNumeroSpam"
                    >
                      <v-icon color="error">mdi-block-helper</v-icon>
                    </v-btn>
                  </template>
                  <span>Bloquear spam</span>
                </v-tooltip>

                <v-tooltip
                  v-if="puedeExportarConversacionIA || puedeAccionesSusanaUnificado"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      @click="abrirJsonConversacionIA('twilio-unificado')"
                    >
                      <v-icon color="#54656f">mdi-code-json</v-icon>
                    </v-btn>
                  </template>
                  <span>JSON IA</span>
                </v-tooltip>

                <v-tooltip
                  v-if="puedeAccionesSusanaUnificado"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      @click="descargarConversacionIADirecto('twilio-unificado')"
                    >
                      <v-icon color="#54656f">mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar conversación</span>
                </v-tooltip>

                <v-tooltip
                  v-if="puedeAccionesSusanaUnificado && mostrarBotonTomarControl"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      color="orange darken-2"
                      :loading="accionControl"
                      @click="tomarControlConversacion"
                    >
                      <v-icon>mdi-account-tie</v-icon>
                    </v-btn>
                  </template>
                  <span>Tomar control</span>
                </v-tooltip>

                <v-tooltip
                  v-if="puedeAccionesSusanaUnificado && mostrarBotonDevolverIa"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      color="teal"
                      :loading="accionControl"
                      @click="devolverControlIa"
                    >
                      <v-icon>mdi-robot</v-icon>
                    </v-btn>
                  </template>
                  <span>Regresar IA</span>
                </v-tooltip>

                <v-tooltip
                  v-if="[1, 3, 568, 334, 3015, 2268, 2155, 2472, 1312, 2767, 2556, 2910].includes(getdatosUsuarioERPERP.iderp) && !chat.folio"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      @click="dialogAsignar.estatus = true"
                    >
                      <v-icon color="#54656f">mdi-account-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Asignar</span>
                </v-tooltip>

                <v-tooltip
                  v-if="chat.sucursal"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      @click="cerrarContacto()"
                    >
                      <v-icon color="#54656f">mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Cerrar contacto</span>
                </v-tooltip>

                <v-menu top offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" v-if="chat.idetiquetas != 6">
                      <v-icon color="#54656f">mdi-label-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item v-for="(item, index) in etiquetas2" :key="index" @click="cambiarCategoria(item.idetiquetas)">
                      <v-list-item-title class="text-caption">
                        <v-icon small :color="item.color">mdi-label</v-icon>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-btn icon small @click="dialogComentariosAbiertoChat = true">
                  <v-icon color="#54656f">mdi-comment-plus-outline</v-icon>
                </v-btn>

                <v-btn icon small @click="dialogDescrip = true">
                  <v-icon color="#54656f">mdi-dots-vertical</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Fuera del header: no empuja ni oculta la flecha atrás en móvil / panel estrecho -->
            <div
              v-if="mostrarPosibleVendedora"
              class="wa-posible-banner"
            >
              <v-icon small color="success" class="mr-1 flex-shrink-0">mdi-account-star-outline</v-icon>
              <div class="wa-posible-banner-text">
                <span class="wa-posible-banner-label">Posible asignar</span>
                <span class="wa-posible-banner-name">{{
                  posibleVendedora.nombre_vendedora_posible || ('#' + posibleVendedora.id_vendedora_posible)
                }}</span>
              </div>
              <v-btn
                v-if="puedeGestionarSusanaConfig && posibleVendedora.puede_aceptar"
                small
                depressed
                color="primary"
                class="flex-shrink-0"
                :loading="aceptandoPosible"
                @click="aceptarPosibleVendedora"
              >
                Aceptar
              </v-btn>
            </div>

            <section class="wa-chat-area">
              <v-container
                id="scroll-target"
                v-scroll:#scroll-target="onScroll"
                class="wa-messages-scroll overflow-y-auto elevation-0"
              >
                <MensajesWppTwilio
                  class="messages-chat elevation-0"
                  id="mensajesChat"
                  :whatsappStyle="true"
                  :mensajes="mensajes"
                  :alumno="alumno"
                  :wha="wha"
                  :chat="chat"
                  :verTodosLosMensajes="verTodosLosMensajes"
                  :analysisIA="analysisIA"
                  :asignacion="asignacion"
                  :numeroTwilio="chat.numeroTwilio"
                  :mostrarBotIA="puedeVerBotIAUnificado"
                  :composerDeshabilitadoPorControl="chatSoloLecturaCerrado || (puedeAccionesSusanaUnificado && composerBloqueadoPorIa)"
                  :mensajeComposerDeshabilitado="chatSoloLecturaCerrado ? 'Contacto bloqueado (spam) — solo lectura' : ''"
                  :mostrarAccionTomarControl="!chatSoloLecturaCerrado && puedeAccionesSusanaUnificado && mostrarBotonTomarControl"
                  :cargandoAccionControl="accionControl"
                  @tomar-control="tomarControlConversacion"
                  @validayGuardaMensajes="validayGuardaMensajes"
                  :chats="allChats"
                  @verChat="verChat"
                />
              </v-container>
            </section>
          </template>
        </v-col>
      </v-row>
    </v-card>

      <v-dialog v-model="dialogDescrip" max-width="500px" transition="dialog-transition">
        <v-card>
          <v-card-title primary-title>
            Etiquetas
          </v-card-title>
          <v-card-text class="black--text">
            <div v-for="(etiqueta, i) in etiquetas">
              <v-icon :color="etiqueta.color">mdi-label</v-icon><b>{{ etiqueta.etiqueta }}</b>

              <br />
              {{ etiqueta.detalles }}

              <br />
              <br />
              <v-divider></v-divider>
            </div>

          </v-card-text>

        </v-card>
      </v-dialog>

      <!-- Diálogo para comentarios -->
      <v-dialog v-model="dialogComentariosAbiertoChat" max-width="600px" scrollable>
        <v-card v-if="chat && chat.idprospectos">
          <v-card-title class="headline">
            <v-icon small class="mr-2">mdi-chat-multiple</v-icon>
            Comentarios del Prospecto
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="min-height: 400px;">
            <ComentariosProspecto :idProspecto="chat.idprospectos" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogComentariosAbiertoChat = false">
              <v-icon small class="mr-1">mdi-close</v-icon>
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <MensajesPredeterminados :openDialogMensajes="openDialogMensajes" v-if="openDialogMensajes.estatus"
        :alumno="alumno" />

      <ReasignarProspecto
        :dialogReasignar="dialogReasignar"
        v-if="dialogReasignar.estatus"
        :alumno="alumno"
        :wha="wha"
        :chat="chat"
        :chats="chatsParaReasignar"
        :escuela="1"
        @reasignado="onReasignacionManual"
      />

      <AsignarProspecto :escuela="1" :dialogAsignar="dialogAsignar" v-if="dialogAsignar.estatus" :alumno="alumno"
        :wha="wha" :chat="chat" />


      <!-- Dialog Evaluación -->
<v-dialog
  v-model="dialogEvaluacion"
  max-width="600px"
  persistent
>
  <v-card>
    <v-card-title class="text-subtitle-1">
      Evaluación de Conversación
    </v-card-title>
    <v-card-text>
      <div v-if="chat" class="mb-3">
        <div><b>Folio:</b> {{ chat.folio || 'Sin folio' }}</div>
        <div><b>Usuario:</b> {{ chat.usuario }}</div>
      </div>
      
      <v-divider class="my-3"></v-divider>
      
      <div v-if="preguntasEvaluacion.length === 0" class="text-center py-4">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <div class="mt-2">Cargando preguntas...</div>
      </div>
      
      <div v-else>
        <v-list dense>
          <v-list-item
            v-for="(pregunta, index) in preguntasEvaluacion"
            :key="pregunta.id"
          >
          <v-list-item-content>
  <div 
    class="text-body-2"
    style="white-space: normal; word-wrap: break-word; line-height: 1.5; padding: 4px 0;"
  >
    {{ pregunta.pregunta }}
  </div>
</v-list-item-content>
              <v-switch
                v-model="evaluacionEditada[pregunta.id]"
                :value="true"
                :color="!evaluacionEditada[pregunta.id] ? 'gray' : 'primary'"
                hide-details
              >
              <template v-slot:label>
                <span 
                  :class="!evaluacionEditada[pregunta.id] ? 'gray--text' : 'primary--text'"
                  class="font-weight-medium"
                >
                  {{ evaluacionEditada[pregunta.id] ? 'Sí' : 'No' }}
                </span>
              </template>
              </v-switch>
          </v-list-item>
        </v-list>
        
        <v-alert
          v-if="preguntasEvaluacion.some(p => p.valor !== null)"
          type="info"
          dense
          class="mt-3"
        >
          Esta evaluación ya fue completada. Puedes actualizarla.
        </v-alert>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="grey"
        dark
        small
        @click="dialogEvaluacion = false"
      >
        Cancelar
      </v-btn>
      <v-btn
        color="primary"
        dark
        small
        @click="guardarEvaluacion"
        :disabled="!puedeGuardarEvaluacion"
      >
        Guardar
        <v-icon right small>mdi-content-save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

      <!-- Dialog de carga -->
      <DialogJsonConversacionIA
        v-if="puedeExportarConversacionIA"
        v-model="dialogJsonConversacionIA"
        :jsonStr="jsonConversacionIA"
        @copiar="copiarJsonConversacionIA"
        @descargar="descargarJsonConversacionIA"
      />

      <v-dialog v-model="dialogLimpiarAgente" max-width="420" persistent>
        <v-card>
          <v-card-title class="text-subtitle-1">
            {{ modoLimpiarAgente === 'todo' ? 'Borrar conversación' : 'Reiniciar contexto IA' }}
          </v-card-title>
          <v-card-text class="text-body-2">
            <template v-if="modoLimpiarAgente === 'todo'">
              Se borrarán <strong>todos los mensajes</strong> de este chat
              y se reiniciará el contexto / perfil VIA.
              Esto no se puede deshacer.
            </template>
            <template v-else>
              Se reinicia el <strong>contexto y perfil VIA</strong> (borradores, control, datos).
              Los mensajes de WhatsApp <strong>se conservan</strong>.
            </template>
            <div v-if="chat" class="mt-3 grey--text text-caption">
              {{ chat.usuario }}
              <span v-if="chat.folio"> · Folio {{ chat.folio }}</span>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text :disabled="limpiandoAgente" @click="dialogLimpiarAgente = false">Cancelar</v-btn>
            <v-btn
              :color="modoLimpiarAgente === 'todo' ? 'error' : 'teal darken-1'"
              dark
              depressed
              :loading="limpiandoAgente"
              @click="confirmarLimpiarAgente"
            >
              {{ modoLimpiarAgente === 'todo' ? 'Borrar todo' : 'Reiniciar CTX' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <Alerta v-if="respuestaAlerta" :parametros="parametros" />
      <carga v-if="cargar" />
  </v-container>
</template>
<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex'
// import { io } from "socket.io-client";

// Componentes
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue';

import MensajesWppTwilio from '@/components/whatsapp/MensajesTwilioWpp.vue';
import ListaContactos from '@/components/whatsapp/ListaContactos.vue';
import Toolbar from '@/components/whatsapp/Toolbar.vue';
import MensajesPredeterminados from '@/components/whatsapp/MensajesPredeterminados.vue';
import ReasignarProspecto from '@/components/whatsapp/ReasignarProspecto.vue';
import AsignarProspecto from '@/components/whatsapp/AsignarProspecto.vue';
import ComentariosProspecto from '@/components/ComentariosProspecto.vue';
import DialogJsonConversacionIA from '@/components/whatsapp/DialogJsonConversacionIA.vue';

import validarErrores from '@/mixins/validarErrores'
import mixinWhatsApp from '@/mixins/mixinWhatsApp'
import mixinEstatusWha from '@/mixins/mixinEstatusWha'
import mixinExamenTwilioAbrir from '@/mixins/mixinExamenTwilioAbrir'
import mixinTwilioWhatsAppLayout from '@/mixins/mixinTwilioWhatsAppLayout'
import mixinTwilioChatTiming from '@/mixins/mixinTwilioChatTiming'
import mixinExportarConversacionTwilioIA from '@/mixins/mixinExportarConversacionTwilioIA'
import mixinVendedorIaPanel from '@/mixins/mixinVendedorIaPanel'
import { chatCoincideBusquedaTwilio } from '@/utils/examenUbicacionNotify'
import { chatTieneFichaTecnica } from '@/utils/twilioFichaTecnica'
import {
  debeOcultarChatSinProspectoPuesto18,
  chatTieneFolioOProspecto,
  chatViaAgenteIA,
  mensajeLimpiaReasignado,
} from '@/utils/twilioVendedoraProspecto'
import { esUsuarioTwilioAdmin } from '@/config/twilioUsuariosAdmin'
import { chatsParaHoraMenuEncargadas } from '@/utils/twilioFechaMexico'

/** Timestamp comparable (ISO o "YYYY-MM-DD HH:mm:ss" México). */
function fechaUltimoMensajeMs (chat) {
  if (!chat) return 0
  const raw =
    chat.fecha_ultimo_mensaje ||
    chat.ultimmensaje ||
    chat.ultimomensaje ||
    chat.fecha_creacion ||
    ''
  if (!raw) return 0
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw
  const s = String(raw).trim()
  // MySQL / bump México sin zona → interpretar como America/Mexico_City (UTC-6)
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s)) {
    const tMx = Date.parse(s.replace(' ', 'T') + '-06:00')
    if (Number.isFinite(tMx)) return tMx
  }
  const isoLike = s.includes('T') ? s : s.replace(' ', 'T')
  const t = Date.parse(isoLike)
  if (Number.isFinite(t)) return t
  const t2 = new Date(s).getTime()
  return Number.isFinite(t2) ? t2 : 0
}

/** Misma forma que MySQL / API Unificado: YYYY-MM-DD HH:mm:ss en México. */
function formatFechaMexicoFront (value = Date.now()) {
  let d
  if (value instanceof Date) d = value
  else if (typeof value === 'number' && Number.isFinite(value)) d = new Date(value)
  else if (value != null && String(value).trim() !== '') {
    const s = String(value).trim()
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s)) return s
    d = new Date(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s) ? s.replace(' ', 'T') + '-06:00' : s)
  } else {
    d = new Date()
  }
  if (!Number.isFinite(d.getTime())) d = new Date()
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Mexico_City',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(d)
    const get = (type) => {
      const p = parts.find((x) => x.type === type)
      return p ? p.value : '00'
    }
    const hour = get('hour') === '24' ? '00' : get('hour')
    return `${get('year')}-${get('month')}-${get('day')} ${hour}:${get('minute')}:${get('second')}`
  } catch (_) {
    const p = (n) => String(n).padStart(2, '0')
    const local = new Date(d.getTime() - 6 * 60 * 60 * 1000)
    return `${local.getUTCFullYear()}-${p(local.getUTCMonth() + 1)}-${p(local.getUTCDate())} ${p(local.getUTCHours())}:${p(local.getUTCMinutes())}:${p(local.getUTCSeconds())}`
  }
}

function ordenarChatsPorMasReciente (lista) {
  return (Array.isArray(lista) ? lista : []).slice().sort((a, b) => {
    const scoreA = a && a.tiemporestante != null && a.tiemporestante !== ''
      ? (Number(a.tiemporestante) > 0 ? 1 : 0)
      : (Number(a && a.ventanaCerrada) === 0 ? 1 : 0)
    const scoreB = b && b.tiemporestante != null && b.tiemporestante !== ''
      ? (Number(b.tiemporestante) > 0 ? 1 : 0)
      : (Number(b && b.ventanaCerrada) === 0 ? 1 : 0)
    if (scoreB !== scoreA) return scoreB - scoreA

    const tb = fechaUltimoMensajeMs(b)
    const ta = fechaUltimoMensajeMs(a)
    if (tb !== ta) return tb - ta
    return (Number(b.sinleer) || 0) - (Number(a.sinleer) || 0)
  })
}

export default {
  components: {
    Alerta,
    carga,
    MensajesWppTwilio,
    ListaContactos,
    Toolbar,
    MensajesPredeterminados,
    ReasignarProspecto,
    AsignarProspecto,
    ComentariosProspecto,
    DialogJsonConversacionIA,
  },

  mixins: [validarErrores, mixinEstatusWha, mixinWhatsApp, mixinExamenTwilioAbrir, mixinTwilioWhatsAppLayout, mixinTwilioChatTiming, mixinExportarConversacionTwilioIA, mixinVendedorIaPanel],


  data: () => ({
    unificar: true,
    skipMixinWhatsAppInit: true,
    dialogDescrip: false,
    dialogComentariosAbiertoChat: false,

    analysisIA: {},
    _analyzeChatTimer: null,
    buscarPregunta: '',
    buscarActive: false,

    // Alertas
    parametros: {
      dialogError: false,
      mensaje: '',
      color: ''
    },

    respuestaAlerta: false,
    cargar: false,
    limpiandoAgente: false,
    dialogLimpiarAgente: false,
    modoLimpiarAgente: 'contexto',
    bloqueandoNumero: false,

    usuarios: [],

    usuario: null,
    buscarUsuario: '',
    buscarUsuarioActive: true,
    avisoBusquedaCerrado: null,
    cargandoBusquedaCerrado: false,
    timerBusquedaCerrado: null,
    reqBusquedaCerrado: 0,
    alumno: null,
    url: 'https://escuelakpi.club/kpi/whatsapp-imagenes/',

    notSeen: false,
    searchMensaje: '',
    mensajes: [],
    chat: null,

    susanaTodosActivo: true,
    cargandoSusanaConfig: false,
    posibleVendedora: null,
    cargandoPosible: false,
    aceptandoPosible: false,

    alumnos:[],

    wha: null,
    notResponse: false,

    verTodosLosMensajes: 0,
    message: '',

    parametrosAsignarVendedora: {
      estatus: false
    },
    asignacion: null,
    conversaciones: [],
    asignados: [],
    loader: true,

    sonido: null,

    numeroTwilio: "",

    offsetTop: 0,

    limite: 30,
    tiempoCargaMs: null,

    // Temporal: admin con 500 ocultaba contactos recientes poco activos (búsqueda solo local).
    chatsLimitPedido: 2000,
    chatsPagination: {
      hasMore: false,
      offset: 0,
      returned: 0,
      limit: 2000,
    },
    /** Chats del equipo para el menú (no se vacía al filtrar una vendedora). */
    chatsEquipoSnapshot: [],

    filtroFuego: false,
    filtroCartera: false,
    filtroFinalizo: false,
    filtroAgenteIA: false,
    filtroSinProspecto: false,
    filtroHielo: false,
    filtroRecomendados: false,
    filtroSinProspectoNoInteres:false,
    filtroMensajes: false,
    filtroTiempo: false,

    filtroVistos: false,
    etapa: 8,
    etiqueta: null,

    filtroTiempo: false,

    escuela: 1,
    filtroVendedora: null,

    openDialogMensajes: {
      estatus: false
    },

    dialogReasignar: {
      estatus: false
    },
    /** true = reasignar chatsSeleccionados; false = solo el chat abierto */
    reasignacionMasiva: false,
    chatsSeleccionados: [],

    dialogAsignar: {
      estatus: false
    },

    filtroCiudad: 'todas',
    ciudades: [
      { text: 'Todas', value: 'todas' },
      { text: 'CDMX', value: 'cdmx' },
      { text: 'Monterrey', value: 'mty' },
      { text: 'Guadalajara', value: 'gdl' },
      { text: 'Sucursal', value: 'scr' },
    ],
    filtroIncompletos: null,
    opcionesIncompletos: [
      { text: 'Incompletos con interés', value: 'con_interes' },
      { text: 'Incompletos sin interés', value: 'sin_interes' },
      { text: 'Sin incompletos', value: 'sin_incompletos' },
    ],
    twiliosByCities: { "mty": "whatsapp:+5218187047279", "cdmx": "whatsapp:+5215545703336", "gdl": "whatsapp:+5213316971156" },
    allChats: [],
    accesos: [334, 3015, 32, 1, 718, 568, 2574, 2556, 2230, 954, 2354, 2767, 2817, 1312, 2910, 3042, 2548 ],
    conteoTiempoVendedores: {},
    vendedoras_plantel: [],
    filtroUsuarioAsignado: 'todas',
    prospectosChats: [],

    dialogEvaluacion: false,
    preguntasEvaluacion: [],
    evaluacionEditada: {},

  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    ...mapGetters('twilio', ['getConversacionesUnif']),

    accesosBoton() {

      return esUsuarioTwilioAdmin(this.getdatosUsuarioERPERP.iderp) || [568, 334, 1, 32, 2556, 2230, 954, 2354, 2767, 2817, 1312, 2548].includes(this.getdatosUsuarioERPERP.iderp)

    },

    /** Encargada con vendedoras en respaldo_crm. No usar accesosBoton: 1152 está en la lista admin. */
    tieneEquipoCrm() {
      return Array.isArray(this.vendedorasTwilio) && this.vendedorasTwilio.length > 0
    },

    /** Bot IA: exclusivo usuario ERP 2993 en esta vista */
    puedeVerBotIAUnificado () {
      return Number(this.getdatosUsuarioERPERP.iderp) === 2993
    },

    /** Spam bloqueado: ver historial sin enviar. Ventana 24h la maneja MensajesTwilioWpp (tiemporestante). */
    chatSoloLecturaCerrado () {
      return !!(this.chat && Number(this.chat.idetiquetas) === 6)
    },

    /** Filtro lista: ficha técnica / finalizo (admins + Susana) */
    puedeVerFiltroFinalizo () {
      return [1, 28, 334, 568, 3176].includes(Number(this.getdatosUsuarioERPERP.iderp))
    },

    /** Acciones Agente (CTX / borrar / spam / export) para Susana Zavala */
    puedeAccionesSusanaUnificado () {
      return Number(this.getdatosUsuarioERPERP.iderp) === 3176
    },

    /** Kill switch + aceptar posible vendedora */
    puedeGestionarSusanaConfig () {
      return [1, 32, 334, 3176].includes(Number(this.getdatosUsuarioERPERP.iderp))
    },

    /** Chip permanente "IA" en lista (entró por Susana) */
    puedeVerMarcaIaSusana () {
      return [1, 32, 334, 568].includes(Number(this.getdatosUsuarioERPERP.iderp))
    },

    /** Filtro Agente IA en barra */
    puedeVerFiltroAgenteIA () {
      return [1, 28, 334, 568].includes(Number(this.getdatosUsuarioERPERP.iderp))
    },

    puedeReasignarMasivo () {
      return [1, 334, 568, 2767].includes(Number(this.getdatosUsuarioERPERP.iderp))
    },

    chatsParaReasignar () {
      if (this.reasignacionMasiva && this.chatsSeleccionados.length) {
        return this.chatsSeleccionados
      }
      return null
    },

    mostrarPosibleVendedora () {
      return !!(
        this.posibleVendedora
        && this.posibleVendedora.id_vendedora_posible
        && Number(this.chat && this.chat.usuario_asignado) === 3176
      )
    },

    /**
     * Chats para el menú de encargadas: mismos filtros de la lista
     * (ciudad, cartera, fuego, etapa…) pero SIN filtrar por vendedora ni
     * forzar mio=0 en reasignados. Así la hora usa el último mensaje real del cliente.
     */
    chatsMenuEncargadas () {
      let chats = (this.chatsEquipoSnapshot && this.chatsEquipoSnapshot.length)
        ? this.chatsEquipoSnapshot
        : this.getConversacionesUnif
      if (!Array.isArray(chats)) return []

      if (Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto) === 18) {
        chats = chats.filter(el => chatTieneFolioOProspecto(el))
      }

      if (this.filtroCiudad && this.filtroCiudad !== 'todas') {
        chats = chats.filter(el => {
          if (this.filtroCiudad == 'scr') {
            return !['cdmx', 'mty', 'gdl'].includes(el.city)
          }
          return el.city == this.filtroCiudad
        })
      }

      if (this.filtroCartera) {
        return chats.filter(el => Number(el.cartera_fuego) === 1)
      }
      chats = chats.filter(el => Number(el.cartera_fuego) !== 1)

      if (this.filtroFinalizo) chats = chats.filter(chatTieneFichaTecnica)
      if (this.filtroAgenteIA) chats = chats.filter(chatViaAgenteIA)
      if (this.filtroFuego && !this.filtroHielo) chats = chats.filter(el => el.nombre == '🔥')
      if (this.filtroMensajes) chats = chats.filter(el => Number(el.totalMensajes) >= 4)
      if (this.filtroHielo && !this.filtroFuego) chats = chats.filter(el => el.nombre == '🧊')
      if (this.filtroRecomendados) chats = chats.filter(el => Number(el.es_recomendado) === 1)
      if (this.etapa && this.etapa != 8) chats = chats.filter(el => el.idetapa == this.etapa)
      if (this.etiqueta) chats = chats.filter(el => el.idetiquetas == this.etiqueta.idetiquetas)
      if (this.filtroIncompletos == 'con_interes') {
        chats = chats.filter(el => !el.folio && Number(el.totalMensajes) >= 2)
      } else if (this.filtroIncompletos == 'sin_interes') {
        chats = chats.filter(el => !el.folio && Number(el.totalMensajes) < 2)
      } else if (this.filtroIncompletos == 'sin_incompletos') {
        chats = chats.filter(el => el.folio)
      }
      if (this.filtroTiempo) {
        if (this.filtroTiempo.idtiempos == 1) chats = chats.filter(el => el.tiemporestante > 2)
        else if (this.filtroTiempo.idtiempos == 2) chats = chats.filter(el => el.tiemporestante > 0 && el.tiemporestante <= 2)
        else if (this.filtroTiempo.idtiempos == 3) chats = chats.filter(el => el.tiemporestante <= 0)
      }
      return chats
    },

    chatsHoraEncargadas () {
      const idSel = this.filtroVendedora && !this.filtroVendedora.esTodos
        ? Number(
            this.filtroVendedora.iderp ||
            this.filtroVendedora.id_usuario_asignado ||
            this.filtroVendedora.idusuario
          )
        : 0
      return chatsParaHoraMenuEncargadas(this.chatsMenuEncargadas, this.filterChats, idSel)
    },

    filterChats() {
      let arr = []

      // console.log( 'Seleccione un chat' )
      let chats = this.getConversacionesUnif

      // Validar que chats sea un array
      if (!Array.isArray(chats)) {
        console.warn('filterChats: getConversacionesUnif no es un array', chats);
        return []
      }

      // Reasignados: forzar sinleer=1 y mio=0 para chip azul y orden
      chats = chats.map((el) => {
        if (!el || Number(el.reasignado) !== 1) return el
        const sinleer = Math.max(Number(el.sinleer) || 0, 1)
        if (sinleer === Number(el.sinleer) && Number(el.mio) === 0) return el
        return { ...el, sinleer, mio: 0 }
      })

      // Puesto 18: sin folio ni idprospectos no se muestra (evita bumps de socket sin CRM)
      if (Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto) === 18) {
        chats = chats.filter(el => chatTieneFolioOProspecto(el))
      }

      // Vendedoras/encargadas sin permiso admin: solo conversaciones propias asignadas
      if (
        !this.accesosBoton &&
        !this.filtroVendedora &&
        !(this.vendedorasTwilio && this.vendedorasTwilio.length)
      ) {
        const miId = Number(this.getdatosUsuarioERPERP.iderp)
        chats = chats.filter(el => Number(el.usuario_asignado) === miId)
      }

      // Admin: filtrar en la lista ya cargada (si recarga con el iderp de la vendedora
      // la API oculta alumnos ligados y “desaparece” un asignado).
      const idVendedoraSel = this.filtroVendedora && !this.filtroVendedora.esTodos
        ? Number(
            this.filtroVendedora.iderp ||
            this.filtroVendedora.id_usuario_asignado ||
            this.filtroVendedora.idusuario
          )
        : 0
      if (this.accesosBoton && idVendedoraSel > 0) {
        chats = chats.filter(el => Number(el.usuario_asignado) === idVendedoraSel)
      }

      if (this.buscarUsuario) {
        const q = String(this.buscarUsuario).trim()
        chats = chats.filter(el => chatCoincideBusquedaTwilio(el, q))
      }

      // Estilo WhatsApp: el más reciente siempre arriba
      chats = ordenarChatsPorMasReciente(chats)

      // Filtro por ciudad
      if (this.filtroCiudad !== 'todas') {
        chats = chats.filter(el => {
          if (this.filtroCiudad == 'scr') {
            return !['cdmx', 'mty', 'gdl'].includes(el.city)
          } else {
            if (el.city) {
              return el.city == this.filtroCiudad
            }
          }
          return false
        })
      }

      // if (this.filtroUsuarioAsignado !== 'todas') {
      //   chats = chats.filter(el => {
      //     if (el.usuario_asignado) {
      //       return el.usuario_asignado == this.filtroUsuarioAsignado
      //     }
      //     return false
      //   })
      // }

      if (this.filtroCartera) {
        // Backend ya mandó soloCartera; reforzar por si el store tenía basura
        chats = chats.filter(el => Number(el.cartera_fuego) === 1)
        this.conteoEtiquetas(chats)
        this.conteoTiempos(chats)
        this.conteoIncompletos(chats)
        return chats
      }

      // Lista normal: ocultar etiquetados de cartera (solo se ven con billetera)
      chats = chats.filter(el => Number(el.cartera_fuego) !== 1)

      // Ficha técnica: NO usar solo folio (se asigna al crear prospecto IA).
      // Señal: id_vendedora_posible (cierre) o texto de pre-registro en preview.
      if (this.filtroFinalizo) {
        chats = chats.filter(chatTieneFichaTecnica)
        this.conteoEtiquetas(chats)
        this.conteoTiempos(chats)
        this.conteoIncompletos(chats)
        return chats
      }

      if (this.filtroAgenteIA) {
        chats = chats.filter(chatViaAgenteIA)
      }

      if (this.filtroFuego && !this.filtroHielo) {
        chats = chats.filter(el => el.nombre == '🔥')
      }

      if (this.filtroMensajes) {
        chats = chats.filter(el => Number(el.totalMensajes) >= 4)
      }

      if (this.filtroHielo && !this.filtroFuego) {
        chats = chats.filter(el => el.nombre == '🧊')
      }

      if (this.filtroRecomendados) {
        chats = chats.filter(el => Number(el.es_recomendado) === 1)
      }

      if (this.etapa && this.etapa != 8) {

        chats = chats.filter(el => el.idetapa == this.etapa)

      }

      if (this.filtroVistos) {

        chats = chats.filter(el => el.mio == 0)

      }

      // Conteos del menú: calcular antes del filtro de etiqueta activa
      this.conteoEtiquetas(chats)

      if (this.etiqueta) {

        chats = chats.filter(el => el.idetiquetas == this.etiqueta.idetiquetas)

      }

      this.conteoIncompletos(chats)

      if( this.filtroIncompletos ){
        if( this.filtroIncompletos == 'con_interes' ){
          chats = chats.filter(el => !el.folio && Number(el.totalMensajes) >= 2)
        } else if( this.filtroIncompletos == 'sin_interes' ){
          chats = chats.filter(el => !el.folio && Number(el.totalMensajes)  < 2)
        } else if( this.filtroIncompletos == 'sin_incompletos' ){
          chats = chats.filter(el => el.folio )
        }
      }

      this.conteoTiempos(chats)

      if (this.filtroTiempo) {

        if (this.filtroTiempo.idtiempos == 1) {
          chats = chats.filter(el => el.tiemporestante > 2)
        } else if (this.filtroTiempo.idtiempos == 2) {
          chats = chats.filter(el => el.tiemporestante > 0 && el.tiemporestante <= 2)
        } else if (this.filtroTiempo.idtiempos == 3) {
          chats = chats.filter(el => el.tiemporestante <= 0)
        }


      }

      return chats
    },

    filterFiltro() {

      let filtro = [
        { id: 2, text: `Nuevo (${this.getConversacionesUnif.filter(el => el.idetapa == 2).length})` },
        { id: 1, text: `Atrasado (${this.getConversacionesUnif.filter(el => el.idetapa == 1).length})` },
        { id: 4, text: `Con Info (${this.getConversacionesUnif.filter(el => el.idetapa == 4).length})` },
        { id: 5, text: `Sin info (${this.getConversacionesUnif.filter(el => el.idetapa == 5).length})` },
        { id: 7, text: `2da Contacto (${this.getConversacionesUnif.filter(el => el.idetapa == 7).length})` },
        { id: 8, text: `Todos (${this.filterChats.length})` },
      ]

      return filtro
    },

    filterVendedoras() {
      return this.vendedoras.filter(el => el.escuela == this.escuela)
    },

    tamanioPantalla() {
      return this.$vuetify.breakpoint.height - 300
    },
    usuariosAsignados() {
      let list = []
      if (this.vendedorasTwilio && this.vendedorasTwilio.length) {
        list = this.vendedorasTwilio
      } else {
        list = this.vendedoras_plantel
      }

      list.forEach(it => {
        if (it.iderp) {
          it.id_usuario_asignado = it.iderp
        }
        if (it.idusuario) {
          it.id_usuario_asignado = it.idusuario
        }
      })

      return list
    },
    

  },

  watch: {
    filtroVendedora(value) {
      if (this._omitirWatchFiltroVendedora) return
      // Admin sin equipo: filtra en cliente. Encargada (aunque esté en lista admin) sí consulta.
      if (this.accesosBoton && !this.tieneEquipoCrm) return
      this.aplicarFiltroVendedora(value)
    },

    buscarUsuario (value) {
      this.programarValidacionBusquedaCerrado(value)
    },

    filterChats (lista) {
      if (this._pendienteAbrirTwilioTmp && Array.isArray(lista) && lista.length) {
        this.$nextTick(() => this.intentarAbrirChatDesdeTwilioTmp())
      }
    },

    getConversacionesC(val) {
      if (val && val.length) {
        val.forEach(it => it.ciudad = "cdmx")
      }
    },
    getConversacionesM(val) {
      if (val && val.length) {
        val.forEach(it => it.ciudad = "mty")
      }
    },
    getConversacionesG(val) {
      if (val && val.length) {
        val.forEach(it => it.ciudad = "gdl")
      }
    },
    'chat.idprospectos'() {
      if (this.chat && this.chat.idprospectos && this.chat.usuario_asignado) {
        this.obtenerPreguntasEvaluacion()
        this.cargarPosibleVendedora()
      } else {
        this.preguntasEvaluacion = []
        this.posibleVendedora = null
      }
    },
    
    chat: {
      handler(newChat) {
        if (newChat && newChat.idprospectos && newChat.usuario_asignado) {
          this.obtenerPreguntasEvaluacion()
          this.cargarPosibleVendedora()
        } else {
          this.preguntasEvaluacion = []
          this.posibleVendedora = null
        }
      },
      immediate: false
    },

    getConversacionesUnif () {
      this.$nextTick(() => this.tryAbrirChatExamenPendiente())
      this.onStoreChatListUpdated()
    },
  },

  async created() {
    // Una sola carga inicial (el mixin ya no dispara initializeAllCities en paralelo)
    await this.getVendedoras()
    await this.getAccesosCRM()

    if (this.tieneEquipoCrm) {
      // Encargada / con accesos CRM: vista "Todas" del equipo (sin disparar el watch)
      this._omitirWatchFiltroVendedora = true
      this.filtroVendedora = {
        iderp: null,
        id_usuario_asignado: null,
        nombre: 'Todos',
        esTodos: true,
      }
      try {
        await this.getUsersChats()
      } finally {
        this._omitirWatchFiltroVendedora = false
      }
    } else {
      await this.initializeAllCities()
    }

    this.crearTemplateSonido()
    this.getTwilioTmp()
    this.syncPendingExamenDesdeRuta()

    if (this.puedeAccionesSusanaUnificado) {
      this.cargarListaAgentesIa()
    }
    if (this.puedeGestionarSusanaConfig) {
      this.cargarSusanaConfig()
    }
  },

  methods: {
    ...mapActions('twilio', ['guardarConversacionesUnif']),

    /**
     * Actualización en vivo sin loader / sin refetch chatsMCG.
     * Escuchado vía socket twilio-unificado-bump (sala usuario_asignado + admins).
     */
    backgroundUpdateChat (payload) {
      if (!payload || typeof payload !== 'object') return
      const usuario = payload.usuario || payload.from
      if (!usuario) return

      const miId = Number(
        this.getdatosUsuarioERPERP &&
          (this.getdatosUsuarioERPERP.iderp || this.getdatosUsuarioERPERP.id_usuario)
      )
      const asignado = payload.usuario_asignado != null
        ? Number(payload.usuario_asignado)
        : null

      // Defensa extra: vendedora solo ve lo suyo; admin (accesosBoton) ve todo lo emitido a su sala
      if (
        !this.accesosBoton &&
        Number.isFinite(asignado) &&
        asignado > 0 &&
        Number.isFinite(miId) &&
        miId > 0 &&
        asignado !== miId
      ) {
        return
      }

      // Puesto 18: no insertar/actualizar en lista si el bump aún no trae folio ni idprospectos
      // (contactos nuevos por socket antes de CRM)
      const folioBump = payload.folio
      const idProsBump = payload.idprospectos
      const existentePrev = Array.isArray(this.getConversacionesUnif)
        ? this.getConversacionesUnif.find((c) => c && c.usuario === usuario)
        : null
      const candidatoProspecto = {
        folio: folioBump != null ? folioBump : (existentePrev && existentePrev.folio),
        idprospectos: idProsBump != null ? idProsBump : (existentePrev && existentePrev.idprospectos),
      }
      if (debeOcultarChatSinProspectoPuesto18(this.getdatosUsuarioERPERP, candidatoProspecto)) {
        return
      }

      const esMio = Number(payload.mio) === 1
      const limpiaReasignado = mensajeLimpiaReasignado(payload)
      const notifOff = localStorage.getItem('notificaciones') === 'false'
      // Siempre México YYYY-MM-DD HH:mm:ss (nunca toISOString/Z: desordena vs envíos locales)
      const ahoraMs = Date.now()
      const fechaPayload = payload.fecha_ultimo_mensaje || payload.fecha_creacion
      const ahora = formatFechaMexicoFront(fechaPayload || ahoraMs)
      const messageSid = payload.messageSid || null

      let conversaciones = Array.isArray(this.getConversacionesUnif)
        ? [...this.getConversacionesUnif]
        : (Array.isArray(this.allChats) ? [...this.allChats] : [])

      const idx = conversaciones.findIndex((c) => c && c.usuario === usuario)
      let item

      if (idx >= 0) {
        item = {
          ...conversaciones[idx],
          mensaje: payload.mensaje != null ? payload.mensaje : conversaciones[idx].mensaje,
          mio: esMio ? 1 : 0,
          fecha_ultimo_mensaje: ahora,
          _bumpAt: ahoraMs,
          ventanaCerrada: 0,
          tiemporestante: 24,
        }
        if (payload.city) item.city = payload.city
        if (payload.folio) item.folio = payload.folio
        if (payload.idprospectos) item.idprospectos = payload.idprospectos
        if (payload.usuario_asignado != null) item.usuario_asignado = payload.usuario_asignado
        if (payload.nombre_completo) item.nombre_completo = payload.nombre_completo
        if (payload.ProfileName) item.ProfileName = payload.ProfileName
        if (payload.idetapa != null) item.idetapa = payload.idetapa

        conversaciones.splice(idx, 1)
      } else {
        item = {
          usuario,
          mensaje: payload.mensaje || '',
          mio: esMio ? 1 : 0,
          type: payload.type != null ? payload.type : 1,
          fecha_ultimo_mensaje: ahora,
          _bumpAt: ahoraMs,
          ventanaCerrada: 0,
          tiemporestante: 24,
          city: payload.city || 'cdmx',
          ProfileName: payload.ProfileName || null,
          nombre_completo: payload.nombre_completo || payload.ProfileName || null,
          folio: payload.folio || null,
          idprospectos: payload.idprospectos || null,
          usuario_asignado: payload.usuario_asignado || null,
          idetapa: payload.idetapa != null ? payload.idetapa : null,
          existe: true,
          sinleer: 0,
        }
      }

      const chatAbierto = !!(this.chat && this.chat.usuario === usuario)
      // Badge no leídos (no define el orden; el orden es por fecha)
      if (!chatAbierto && !esMio) {
        item.sinleer = (Number(item.sinleer) || 0) + 1
      }
      if (chatAbierto) {
        item.sinleer = 0
      }
      // Lead o asesor humano respondió → quitar chip azul de reasignado
      if (limpiaReasignado) {
        item.reasignado = 0
        if (esMio) item.sinleer = 0
      }

      conversaciones.unshift(item)
      // Reordenar siempre por más reciente → estilo WhatsApp
      conversaciones = ordenarChatsPorMasReciente(conversaciones)

      this.allChats = conversaciones
      if (typeof this.guardarConversacionesUnif === 'function') {
        this.guardarConversacionesUnif(conversaciones)
      }
      try {
        if (typeof this.conteoEtiquetas === 'function') this.conteoEtiquetas(conversaciones)
      } catch (e) { /* ignore */ }

      if (chatAbierto && Array.isArray(this.mensajes)) {
        const ya = messageSid && this.mensajes.some((m) => m && m.messageSid === messageSid)
        if (!ya) {
          this.mensajes.push({
            ...payload,
            usuario,
            twilio: payload.twilio || payload.to,
            mensaje: payload.mensaje,
            mio: esMio ? 1 : 0,
            fecha_creacion: payload.fecha_creacion || ahora,
            messageSid,
          })
          this.$nextTick(() => {
            const el = document.getElementById('scroll-target')
            if (el) el.scrollTop = el.scrollHeight
          })
        }
        if (limpiaReasignado && this.chat) {
          this.$set(this.chat, 'reasignado', 0)
          if (esMio) this.$set(this.chat, 'sinleer', 0)
        }
        if (typeof this.onMensajeTwilioEnVivo === 'function') {
          this.onMensajeTwilioEnVivo(payload)
        }
      }
    },


    async cargarSusanaConfig () {
      try {
        const res = await this.$http.get('via.susana.config')
        this.susanaTodosActivo = !!(res.data && res.data.todos_a_susana)
      } catch (e) {
        console.warn('via.susana.config', e)
      }
    },

    async toggleTodosASusana () {
      if (!this.puedeGestionarSusanaConfig) return
      const next = !this.susanaTodosActivo
      const ok = window.confirm(
        next
          ? '¿Activar Susana? Los contactos nuevos Unificado entrarán al agente.'
          : '¿Detener a Susana? Los contactos nuevos irán al bot / abrirWhatsApp. Los chats actuales de Susana siguen con IA.',
      )
      if (!ok) return
      this.cargandoSusanaConfig = true
      try {
        const res = await this.$http.put('via.susana.config', { todos_a_susana: next ? 1 : 0 })
        this.susanaTodosActivo = !!(res.data && res.data.todos_a_susana)
        this.$toast && this.$toast.success
          ? this.$toast.success(this.susanaTodosActivo ? 'Susana activada' : 'Susana detenida')
          : null
      } catch (e) {
        console.error(e)
        alert((e.response && e.response.data && e.response.data.message) || 'No se pudo actualizar')
      } finally {
        this.cargandoSusanaConfig = false
      }
    },

    async cargarPosibleVendedora () {
      this.posibleVendedora = null
      const id = this.chat && this.chat.idprospectos
      if (!id || Number(this.chat.usuario_asignado) !== 3176) return
      this.cargandoPosible = true
      try {
        const res = await this.$http.post('via.susana.posible', { idprospectos: id })
        this.posibleVendedora = res.data || null
      } catch (e) {
        this.posibleVendedora = null
      } finally {
        this.cargandoPosible = false
      }
    },

    async aceptarPosibleVendedora () {
      if (!this.puedeGestionarSusanaConfig || !this.chat || !this.chat.idprospectos) return
      const nombre = (this.posibleVendedora && this.posibleVendedora.nombre_vendedora_posible) || 'la vendedora sugerida'
      this.aceptandoPosible = true
      try {
        const res = await this.$http.post('via.susana.posible.aceptar', {
          idprospectos: this.chat.idprospectos,
          peer: this.chat.usuario || this.chat.peer || null,
          twilio: this.chat.twilio || this.numeroTwilio || null,
        })
        if (res.data && res.data.ok) {
          this.chat.usuario_asignado = res.data.usuario_asignado
          this.chat.reasignado = 1
          this.chat.sinleer = 1
          this.chat.mio = 0
          this.chat.via_susana = 1
          this.chat.via_ia = 1
          this.chat.utm_source = this.chat.utm_source || 'SUSANA_IA'
          this.aplicarPreviewChatEnLista(this.chat.usuario, {
            usuario_asignado: res.data.usuario_asignado,
            reasignado: 1,
            sinleer: 1,
            mio: 0,
            via_susana: 1,
            via_ia: 1,
            utm_source: this.chat.utm_source || 'SUSANA_IA',
          })
          this.posibleVendedora = {
            ...this.posibleVendedora,
            puede_aceptar: false,
            usuario_asignado: res.data.usuario_asignado,
          }
          if (typeof this.cargarEstadoControlIa === 'function') {
            this.cargarEstadoControlIa()
          }
          this.validarSuccess(`Reasignado a ${res.data.nombre_vendedora || nombre}. IA pausada.`)
        } else {
          this.validarError((res.data && res.data.motivo) || 'No se pudo aceptar')
        }
      } catch (e) {
        this.validarError((e.response && e.response.data && e.response.data.message) || (e.response && e.response.data && e.response.data.motivo) || 'Error al aceptar')
      } finally {
        this.aceptandoPosible = false
      }
    },

    getTwilioTmp(){
      let twilioTmp = sessionStorage.getItem('twilioTmp');
      if (twilioTmp) {
        this.buscarUsuario = twilioTmp;
        sessionStorage.removeItem('twilioTmp');
        if (sessionStorage.getItem('twilioTmpAutoOpen') === '1') {
          this._pendienteAbrirTwilioTmp = String(twilioTmp).trim()
          sessionStorage.removeItem('twilioTmpAutoOpen')
          this.$nextTick(() => this.intentarAbrirChatDesdeTwilioTmp())
        }
      }
    },

    intentarAbrirChatDesdeTwilioTmp () {
      const q = this._pendienteAbrirTwilioTmp
      if (!q) return
      const lista = Array.isArray(this.filterChats) ? this.filterChats : []
      const match = lista.find((chat) => chatCoincideBusquedaTwilio(chat, q))
      if (match) {
        this._pendienteAbrirTwilioTmp = null
        this.verChat(match)
      }
    },

    programarValidacionBusquedaCerrado (value) {
      if (this.timerBusquedaCerrado) {
        clearTimeout(this.timerBusquedaCerrado)
        this.timerBusquedaCerrado = null
      }

      const q = String(value || '').trim()
      if (!q || q.length < 4) {
        this.avisoBusquedaCerrado = null
        this.cargandoBusquedaCerrado = false
        return
      }

      this.timerBusquedaCerrado = setTimeout(() => {
        this.validarBusquedaCerradoEnBd(q)
      }, 450)
    },

    async validarBusquedaCerradoEnBd (q) {
      const query = String(q || '').trim()
      if (!query || query.length < 4) return
      if (String(this.buscarUsuario || '').trim() !== query) return

      const reqId = ++this.reqBusquedaCerrado
      this.cargandoBusquedaCerrado = true

      try {
        const avisoLocal = this.avisoCerradoDesdeChatsCargados(query)
        if (avisoLocal) {
          this.mostrarAvisoCerrado(avisoLocal)
          await this.abrirProspectoCerradoEnVista(query)
          return
        }

        let data = null
        try {
          const response = await this.$http.post('twilio.buscar.cerrado', {
            busqueda: query,
            escuela: 1,
            twilio: this.numeroTwilio || (this.twiliosByCities && this.twiliosByCities.mty) || '',
          })
          data = response.data || {}
        } catch (errBuscar) {
          try {
            data = await this.fallbackBuscarCerradoProspectos(query)
          } catch (errFallback) {
            data = null
            console.warn('No se pudo validar prospecto cerrado', errBuscar, errFallback)
          }
        }

        if (reqId !== this.reqBusquedaCerrado) return
        if (String(this.buscarUsuario || '').trim() !== query) return

        if (data && data.cerrado) {
          this.mostrarAvisoCerrado(data.mensaje || 'Este número y folio ya está cerrado')
          await this.abrirProspectoCerradoEnVista(query, data)
        } else {
          this.avisoBusquedaCerrado = null
        }
      } catch (error) {
        if (reqId !== this.reqBusquedaCerrado) return
        this.avisoBusquedaCerrado = null
        console.warn('Error validando número/folio cerrado', error)
      } finally {
        if (reqId === this.reqBusquedaCerrado) {
          this.cargandoBusquedaCerrado = false
        }
      }
    },

    mostrarAvisoCerrado (mensaje) {
      this.avisoBusquedaCerrado = mensaje
    },

    /** Quita filtros de lista sin recargar API, para que el cerrado no quede oculto. */
    limpiarFiltrosParaBusquedaCerrado () {
      this.filtroMensajes = false
      this.filtroHielo = false
      this.filtroFuego = false
      this.filtroCartera = false
      this.filtroFinalizo = false
      this.filtroAgenteIA = false
      this.filtroVistos = false
      this.etiqueta = null
      this.filtroTiempo = null
      this.filtroSinProspecto = null
      this.filtroIncompletos = null
      this.filtroCiudad = 'todas'
      this.etapa = 8

      this._omitirWatchFiltroVendedora = true
      if (this.tieneEquipoCrm) {
        this.filtroVendedora = {
          iderp: null,
          id_usuario_asignado: null,
          nombre: 'Todos',
          esTodos: true,
        }
      } else if (this.accesosBoton) {
        this.filtroVendedora = null
      }
      this._omitirWatchFiltroVendedora = false
    },

    encontrarChatLocalPorBusqueda (query) {
      const listas = [
        ...(Array.isArray(this.getConversacionesUnif) ? this.getConversacionesUnif : []),
        ...(Array.isArray(this.allChats) ? this.allChats : []),
      ]
      return listas.find((chat) => chatCoincideBusquedaTwilio(chat, query)) || null
    },

    async buscarChatCerradoEnServidor (query) {
      const idusuario = this.getdatosUsuarioERPERP.iderp
      const twilio = this.numeroTwilio
        || (this.twiliosByCities && this.twiliosByCities.mty)
        || (this.twiliosByCities && this.twiliosByCities.cdmx)
        || ''
      if (!twilio) return null

      try {
        const response = await this.$http.post('twilio.chats.buscar', {
          busqueda: query,
          twilio,
          idusuario,
          escuela: 1,
          incluirCerrados: true,
        })
        const data = response.data || {}
        if (!data.encontrado || !data.chat) return null

        const chat = {
          ...data.chat,
          sinleer: data.chat.sinleer || 0,
          finalizo: 1,
          numeroTwilio: data.twilio || data.chat.numeroTwilio || twilio,
        }
        if (!chat.city) {
          const wpp = chat.numeroTwilio
          if (wpp === this.twiliosByCities.cdmx) chat.city = 'cdmx'
          else if (wpp === this.twiliosByCities.mty) chat.city = 'mty'
          else if (wpp === this.twiliosByCities.gdl) chat.city = 'gdl'
          else chat.city = 'mty'
        }
        return chat
      } catch (error) {
        console.warn('No se pudo buscar chat cerrado', error)
        return null
      }
    },

    chatSintenticoDesdeCerrado (query, dataCerrado = null) {
      const tel = String(
        (dataCerrado && dataCerrado.telefono)
        || String(query).replace(/\D/g, '').slice(-10)
        || ''
      ).replace(/\D/g, '').slice(-10)
      if (!tel && !(dataCerrado && dataCerrado.folio)) return null

      const twilio = this.numeroTwilio
        || (this.twiliosByCities && this.twiliosByCities.mty)
        || ''

      return {
        usuario: tel ? `whatsapp:+521${tel}` : `folio:${(dataCerrado && dataCerrado.folio) || query}`,
        folio: (dataCerrado && dataCerrado.folio) || null,
        idprospectos: (dataCerrado && dataCerrado.idprospectos) || null,
        nombre_completo: (dataCerrado && dataCerrado.nombre_completo) || null,
        nombre: (dataCerrado && dataCerrado.nombre_completo) || null,
        usuario_asignado: (dataCerrado && dataCerrado.usuario_asignado) || null,
        finalizo: 1,
        sinleer: 0,
        tiemporestante: 0,
        totalMensajes: 0,
        mensaje: '',
        city: 'mty',
        numeroTwilio: twilio,
        sin_historial_twilio: 1,
      }
    },

    inyectarChatCerradoEnLista (chat) {
      if (!chat || !chat.usuario) return

      const mergeLista = (lista) => {
        const arr = Array.isArray(lista) ? [...lista] : []
        const idx = arr.findIndex((c) => c && c.usuario === chat.usuario)
        if (idx >= 0) {
          arr[idx] = { ...arr[idx], ...chat, finalizo: 1 }
        } else {
          arr.unshift({ ...chat, finalizo: 1 })
        }
        return arr
      }

      const conversaciones = mergeLista(this.getConversacionesUnif)
      this.allChats = mergeLista(this.allChats)
      this.guardarConversacionesUnif(conversaciones)
    },

    async abrirProspectoCerradoEnVista (query, dataCerrado = null) {
      this.limpiarFiltrosParaBusquedaCerrado()

      let chat = this.encontrarChatLocalPorBusqueda(query)
      if (!chat) {
        chat = await this.buscarChatCerradoEnServidor(query)
      }
      if (!chat) {
        chat = this.chatSintenticoDesdeCerrado(query, dataCerrado)
      }
      if (!chat) return

      const enriquecido = {
        ...chat,
        finalizo: 1,
        folio: (dataCerrado && dataCerrado.folio) || chat.folio || null,
        idprospectos: (dataCerrado && dataCerrado.idprospectos) || chat.idprospectos || null,
        nombre_completo: (dataCerrado && dataCerrado.nombre_completo) || chat.nombre_completo || null,
      }

      this.inyectarChatCerradoEnLista(enriquecido)
      await this.$nextTick()
      this.verChat(enriquecido)
    },

    avisoCerradoDesdeChatsCargados (query) {
      const match = this.encontrarChatLocalPorBusqueda(query)
      if (!match || Number(match.finalizo) !== 1) return null
      const tel = String(match.usuario || match.telefono || '').replace(/\D/g, '').slice(-10)
      const folio = match.folio || '—'
      return `Este número ${tel || '—'} y folio ${folio} ya está cerrado`
    },

    async fallbackBuscarCerradoProspectos (query) {
      const digits = String(query).replace(/\D/g, '')
      const last10 = digits.length >= 10 ? digits.slice(-10) : ''
      const looksLikeFolio = /[A-Za-z]/.test(query)
      const payload = {
        telefono: looksLikeFolio ? '' : (last10 || query),
        folio: looksLikeFolio ? query : '',
      }
      const response = await this.$http.post('obtener.prospectos.finalizados', payload)
      const rows = Array.isArray(response.data) ? response.data : []
      const cerrado = rows.find((r) => Number(r.finalizo) === 1 && Number(r.escuela) === 1)
        || rows.find((r) => Number(r.finalizo) === 1)
      if (!cerrado) {
        return { encontrado: rows.length > 0, cerrado: false, mensaje: null }
      }
      const tel = String(cerrado.telefono || '').replace(/\D/g, '').slice(-10)
      const folio = cerrado.folio || '—'
      return {
        encontrado: true,
        cerrado: true,
        folio,
        telefono: tel,
        idprospectos: cerrado.idprospectos,
        mensaje: `Este número ${tel || '—'} y folio ${folio} ya está cerrado`,
      }
    },

    examenListasChats () {
      return [this.getConversacionesUnif, this.allChats]
    },

    examenRecargarChats () {
      return this.initializeAllCities()
    },

    ultimoMensajeDeConversacion (conversacion) {
      const lista = Array.isArray(conversacion) ? conversacion : []
      if (!lista.length) return null
      return lista.reduce((ultimo, actual) => {
        if (!ultimo) return actual
        return new Date(actual.fecha_creacion) > new Date(ultimo.fecha_creacion) ? actual : ultimo
      }, null)
    },

    aplicarPreviewChatEnLista (usuario, patch) {
      if (!usuario || !patch) return

      const actualizar = (lista) => {
        if (!Array.isArray(lista)) return []
        return lista.map((c) => (c.usuario === usuario ? { ...c, ...patch } : c))
      }

      const conversaciones = actualizar(this.getConversacionesUnif)
      this.allChats = actualizar(this.allChats)
      this.guardarConversacionesUnif(conversaciones)
    },

    validayGuardaMensajes (payload = {}) {
      if (!this.chat || !this.chat.usuario) return

      const texto = String(
        payload && payload.mensaje != null ? payload.mensaje : (this.message || '')
      ).trim()

      this.aplicarPreviewChatEnLista(this.chat.usuario, {
        ...(texto ? { mensaje: texto, type: (payload && payload.type) || 1 } : {}),
        mio: 1,
        sinleer: 0,
        reasignado: 0,
        fecha_ultimo_mensaje:
          (payload && payload.fecha_ultimo_mensaje)
          || formatFechaMexicoFront(),
      })

      this.$set(this.chat, 'reasignado', 0)
      this.$set(this.chat, 'sinleer', 0)
      this.$set(this.chat, 'mio', 1)
      if (texto) this.$set(this.chat, 'mensaje', texto)
    },

    /** Tras reasignar desde el diálogo del header: chip azul + puntito al instante */
    onReasignacionManual (payload = {}) {
      const usuarios = Array.isArray(payload.usuarios) && payload.usuarios.length
        ? payload.usuarios
        : [(payload && payload.usuario) || (this.chat && this.chat.usuario)].filter(Boolean)

      if (!usuarios.length) return

      const prospectosPorUsuario = {}
      ;(payload.prospectos || []).forEach((p) => {
        if (p && p.usuario) prospectosPorUsuario[p.usuario] = p
      })

      const patchBase = {
        reasignado: 1,
        sinleer: 1,
        mio: 0,
      }
      if (payload.usuario_asignado != null) {
        patchBase.usuario_asignado = payload.usuario_asignado
      }

      usuarios.forEach((usuario) => {
        const patch = { ...patchBase }
        const creado = prospectosPorUsuario[usuario]
        if (creado) {
          if (creado.idprospectos) patch.idprospectos = creado.idprospectos
          if (creado.folio) patch.folio = creado.folio
        }
        const enLista = (this.getConversacionesUnif || []).find((c) => c && c.usuario === usuario)
        const esChatAbierto = this.chat && this.chat.usuario === usuario
        const refChat = esChatAbierto ? this.chat : enLista

        if (refChat && (Number(refChat.via_ia) === 1 || Number(refChat.via_susana) === 1 || Number(refChat.usuario_asignado) === 3176)) {
          patch.via_ia = 1
          patch.via_susana = 1
        }

        this.aplicarPreviewChatEnLista(usuario, patch)

        if (esChatAbierto) {
          Object.keys(patch).forEach((k) => this.$set(this.chat, k, patch[k]))
          if (payload.nombre_vendedora) {
            const vendedor = Object.assign({}, this.chat.vendedor || {}, { nombre: payload.nombre_vendedora })
            this.$set(this.chat, 'vendedor', vendedor)
            this.aplicarPreviewChatEnLista(usuario, { vendedor })
          }
        } else if (payload.nombre_vendedora) {
          const vendedor = Object.assign({}, (enLista && enLista.vendedor) || {}, { nombre: payload.nombre_vendedora })
          this.aplicarPreviewChatEnLista(usuario, { vendedor })
        }
      })

      this.chatsSeleccionados = []
      this.reasignacionMasiva = false
    },

    abrirReasignacionIndividual () {
      this.reasignacionMasiva = false
      this.dialogReasignar.estatus = true
    },

    abrirReasignacionMasiva () {
      if (!this.chatsSeleccionados.length) {
        return this.validarError('Selecciona al menos un chat en la lista')
      }
      this.reasignacionMasiva = true
      this.dialogReasignar.estatus = true
    },

    onScroll(e) {
      this.offsetTop = e.target.scrollTop
    },

    getNombre(texto) {
      return texto.usuario
    },

    idDeVendedora(item) {
      if (!item || item.esTodos) return 0
      const id = Number(item.iderp || item.id_usuario_asignado || item.idusuario)
      return Number.isFinite(id) && id > 0 ? id : 0
    },

    idsEquipoTwilio() {
      const ids = []
      const lista = (this.vendedorasTwilio && this.vendedorasTwilio.length)
        ? this.vendedorasTwilio
        : (this.vendedoras_plantel || [])
      lista.forEach((it) => {
        const id = this.idDeVendedora(it)
        if (id) ids.push(id)
      })
      const yo = Number(
        (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)
        || (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.id_usuario)
      )
      if (yo > 0) ids.push(yo)

      const vistos = {}
      const unicos = []
      ids.forEach((id) => {
        if (vistos[id]) return
        vistos[id] = true
        unicos.push(id)
      })

      // Las demás primero (Vanessa), la encargada al final
      if (yo > 0) {
        unicos.sort((a, b) => (a === yo ? 1 : b === yo ? -1 : 0))
      }
      return unicos
    },

    mergeChatsPorUsuario(pages) {
      const porUsuario = {}
      ;(pages || []).forEach((lista) => {
        (lista || []).forEach((chat) => {
          if (!chat || !chat.usuario) return
          const prev = porUsuario[chat.usuario]
          if (!prev) {
            porUsuario[chat.usuario] = chat
            return
          }
          const fNew = new Date(chat.fecha_ultimo_mensaje || chat.ultimmensaje || 0).getTime()
          const fOld = new Date(prev.fecha_ultimo_mensaje || prev.ultimmensaje || 0).getTime()
          if (fNew >= fOld) porUsuario[chat.usuario] = chat
        })
      })
      return Object.keys(porUsuario).map((k) => porUsuario[k])
    },

    actualizarChatsEquipoSnapshot(chats, idVendedora) {
      const nuevos = Array.isArray(chats) ? chats.slice() : []
      const id = Number(idVendedora) || 0
      if (!(id > 0)) {
        this.chatsEquipoSnapshot = nuevos
        return
      }
      const resto = (this.chatsEquipoSnapshot || []).filter(
        (c) => Number(c.usuario_asignado) !== id
      )
      this.chatsEquipoSnapshot = resto.concat(nuevos)
    },

    aplicarFiltroVendedora(item) {
      if (this.accesosBoton && !this.tieneEquipoCrm) return
      if (item && item.esTodos) {
        return this.getUsersChats()
      }
      const id = this.idDeVendedora(item)
      if (id > 0) {
        return this.cargarChatsDeVendedora(id)
      }
      return this.initializeAllCities()
    },

    seleccionaVendedora(item) {
      this._omitirWatchFiltroVendedora = true
      this.filtroVendedora = item || null
      this.$nextTick(() => {
        this._omitirWatchFiltroVendedora = false
      })

      if (!item || item.esTodos) {
        this.getUsersChats()
        return
      }

      const id = Number(item.iderp || item.id_usuario_asignado || item.idusuario)
      if (id > 0) {
        this.cargarChatsDeVendedora(id)
        return
      }

      this.initializeAllCities()
    },

    /** Informativo: únicos por teléfono, a tiempo + por vencer. No se pisa al filtrar un vendedor. */
    actualizarConteoTiempoVendedores(chats) {
      if (this.filtroVendedora && !this.filtroVendedora.esTodos) return
      const lista = Array.isArray(chats) ? chats : []
      const vistos = {}
      for (let i = 0; i < lista.length; i++) {
        const chat = lista[i]
        if (!(Number(chat.tiemporestante) > 0)) continue
        const id = Number(chat.usuario_asignado)
        if (!id) continue
        const tel = String(chat.usuario || chat.telefono || '').replace(/\D/g, '').slice(-10)
        if (tel.length < 10) continue
        if (!vistos[id]) vistos[id] = {}
        vistos[id][tel] = true
      }
      const parcial = {}
      Object.keys(vistos).forEach((id) => {
        parcial[id] = Object.keys(vistos[id]).length
      })
      this.conteoTiempoVendedores = parcial
    },

    marcaPromptPorCiudad(city, twilioLinea) {
      const linea = String(twilioLinea || '')
      if (linea.includes('8187047279') || city === 'mty') return 'INBI_MTY'
      if (linea.includes('3316971156') || city === 'gdl') return 'INBI_GDL'
      return 'INBI_CDMX'
    },

    /** Todas las conversaciones visibles (respeta filtros activos). */
    descargarTodasConversaciones() {
      const chats = [...(this.filterChats || [])].sort((a, b) => {
        const fb = b.fecha_ultimo_mensaje || b.ultimmensaje || b.ultimomensaje || ''
        const fa = a.fecha_ultimo_mensaje || a.ultimmensaje || a.ultimomensaje || ''
        return new Date(fb) - new Date(fa)
      })

      if (!chats.length) {
        this.validarError('No hay conversaciones para descargar')
        return
      }

      return this.descargarUltimasConversacionesIA({
        origen: 'twilio-unificado-susana',
        limite: chats.length,
        chats,
        fetchMensajes: async (chat) => {
          let twilio = chat.numeroTwilio || this.numeroTwilio
          if (!twilio && chat.city) {
            if (chat.city === 'cdmx') twilio = this.twiliosByCities.cdmx
            if (chat.city === 'mty') twilio = this.twiliosByCities.mty
            if (chat.city === 'gdl') twilio = this.twiliosByCities.gdl
          }
          const response = await this.$http.post('twilio.chats.unico', {
            twilio,
            usuario: chat.usuario,
          })
          return (response.data && response.data.conversacionCompleta) || []
        },
      })
    },


    verChat(chat) {

      // console.log( 'verChat: ', chat.idprospectos )
      // console.log( 'verChat: ', chat.usuario_asignado )
      
      // Buscar el objeto completo en allChats para asegurar que tenemos todos los campos
      const chatCompleto = this.allChats.find(c => c.usuario === chat.usuario) || chat
      
      // Si no lo encontramos en allChats, buscar en getConversacionesUnif
      if (!chatCompleto.idprospectos || !chatCompleto.usuario_asignado) {
        const chatDelStore = this.getConversacionesUnif.find(c => c.usuario === chat.usuario)
        if (chatDelStore) {
          // Copiar los campos que faltan
          if (chatDelStore.idprospectos) chatCompleto.idprospectos = chatDelStore.idprospectos
          if (chatDelStore.usuario_asignado) chatCompleto.usuario_asignado = chatDelStore.usuario_asignado
        }
      }

      if (!['cdmx', 'mty', 'gdl'].includes(chatCompleto.city)) {
        // Sin ciudad válida: igual intentar cargar en Unificado (API busca en las 3 bases)
        chatCompleto.city = chatCompleto.city || 'cdmx'
      }
      let numeroTwilio = ""
      if (chatCompleto.city == "cdmx") {
        numeroTwilio = this.twiliosByCities.cdmx
      }
      if (chatCompleto.city == "mty") {
        numeroTwilio = this.twiliosByCities.mty
      }
      if (chatCompleto.city == "gdl") {
        numeroTwilio = this.twiliosByCities.gdl
      }
      if (!numeroTwilio) {
        numeroTwilio = this.twiliosByCities.cdmx
      }
      this.numeroTwilio = numeroTwilio
      chatCompleto.numeroTwilio = numeroTwilio
      if (this.puedeVerBotIAUnificado) {
        this.analysisIA = {}
      }
      // Construimos el chat
      const payload = {
        twilio: numeroTwilio,
        usuario: chatCompleto.usuario,
        id_usuario: this.getdatosUsuarioERPERP.id_usuario,
        iderp: this.getdatosUsuarioERPERP.iderp,
        origen: 'unificado',
        modo: true,
        escuela: 1,
      }

      // Vaciamos los mensajes
      const listScrollTop = this.beginVerChatScroll()
      this.mensajes = []

      const t0Chat = this.iniciarTiempoCargaChat()
      // Hacemos la petición de los mensajes
      return this.$http.post('twilio.chats.unico', payload).then(response => {
        this.finalizarTiempoCargaChat(t0Chat)

        // Guardamos los mensajes
        this.mensajes = response.data.conversacionCompleta
        let bloqueo = response.data.bloqueo
        if (response.data.analysisIA) {
          this.analysisIA = response.data.analysisIA
        }

        const ultimoMensaje = this.ultimoMensajeDeConversacion(
          response.data.conversacionCompleta
        )

        if (this.puedeVerBotIAUnificado) {
          const twilioReal =
            (ultimoMensaje && ultimoMensaje.twilio) ||
            payload.twilio
          this.analyzeChatUnificado({ twilio: twilioReal, usuario: payload.usuario })
        }
        const previewUltimo = ultimoMensaje
          ? {
              mensaje: ultimoMensaje.mensaje || '',
              mio: ultimoMensaje.mio,
              type: ultimoMensaje.type != null ? ultimoMensaje.type : 1,
              fecha_ultimo_mensaje: ultimoMensaje.fecha_creacion,
              sinleer: 0,
            }
          : { sinleer: 0 }

        let conversaciones = [...this.allChats]

        for (const i in conversaciones) {
          if (conversaciones[i].usuario === chatCompleto.usuario) {
            conversaciones[i] = { ...conversaciones[i], ...previewUltimo }
          }
        }

        if (bloqueo) {
          chatCompleto.idetiquetas = 6
        }

        // Asegurar que tenemos idprospectos y usuario_asignado antes de asignar
        if (!chatCompleto.idprospectos || !chatCompleto.usuario_asignado) {
          const chatOriginal = conversaciones.find(c => c.usuario === chatCompleto.usuario)
          if (chatOriginal) {
            if (chatOriginal.idprospectos) chatCompleto.idprospectos = chatOriginal.idprospectos
            if (chatOriginal.usuario_asignado) chatCompleto.usuario_asignado = chatOriginal.usuario_asignado
          }
        }

        this.chat = chatCompleto
        this.allChats = conversaciones

        this.guardarConversacionesUnif(conversaciones)

        // Cargar preguntas de evaluación si hay idprospectos y usuario_asignado
        if (chatCompleto.idprospectos && chatCompleto.usuario_asignado) {
          this.obtenerPreguntasEvaluacion()
        }

        if (this.puedeAccionesSusanaUnificado) {
          this.marcaPrompt = this.marcaPromptPorCiudad(chatCompleto.city, numeroTwilio)
          this.alAbrirChatPanelIa()
        }

        this.finishVerChatScroll(listScrollTop)

      }).catch(error => {
        this.limpiarTiempoCargaChat()
        this.validarError(error.response.data.message)
        this.failVerChatScroll(listScrollTop)
      })
    },

    analyzeChatUnificado ({ twilio, usuario }) {
      if (!this.puedeVerBotIAUnificado || !twilio || !usuario) return
      clearTimeout(this._analyzeChatTimer)
      this._analyzeChatTimer = setTimeout(() => {
        this._ejecutarAnalyzeChatUnificado({ twilio, usuario })
      }, 500)
    },

    _ejecutarAnalyzeChatUnificado ({ twilio, usuario }) {
      this.$http.post('/api/analyze-chat', {
        twilio_wpp: twilio,
        user_wpp: usuario,
        origen: 'unificado',
        iderp: this.getdatosUsuarioERPERP.iderp,
      }).then(response => {
        const payload = response.data && response.data.analysis
          ? response.data.analysis
          : response.data
        if (payload && (payload.recommendation || payload.suggested_messages)) {
          this.analysisIA = payload
          this.$forceUpdate()
        }
      }).catch(error => {
        const status = error.response && error.response.status
        if (status === 403 || status === 422) {
          const data = error.response && error.response.data ? error.response.data : {}
          console.warn('[analyze-chat unificado]', status, data.error || data.message)
          return
        }
        const data = error.response && error.response.data ? error.response.data : {}
        const msg = data.detail
          ? `${data.error || 'Error IA'}: ${data.detail}`
          : (data.error || data.message || error.message)
        console.warn('[analyze-chat unificado]', msg)
      })
    },

    validarMensajeEntrante (body) {
      if (!body) return
      const { usuario, twilio, mensaje, type, mio } = body
      const esChatActivo = this.chat && this.chat.usuario === usuario

      if (esChatActivo) {
        this.mensajes.push(body)
        if (this.puedeVerBotIAUnificado) {
          this.analyzeChatUnificado({
            twilio: twilio || this.chat.numeroTwilio,
            usuario,
          })
        }
      }

      const patch = {
        mensaje: mensaje || '',
        mio: mio != null ? mio : 0,
        type: type != null ? type : 1,
        sinleer: esChatActivo ? 0 : 1,
        fecha_ultimo_mensaje: formatFechaMexicoFront(),
      }
      if (mensajeLimpiaReasignado(body)) {
        patch.reasignado = 0
        if (Number(body.mio) === 1) patch.sinleer = 0
        if (this.chat && this.chat.usuario === usuario) {
          this.$set(this.chat, 'reasignado', 0)
        }
      }

      this.aplicarPreviewChatEnLista(usuario, patch)
    },

    async abrirDialogEvaluacion() {
    if (!this.chat || !this.chat.idprospectos || !this.chat.usuario_asignado) {
      this.validarError('No se puede evaluar: faltan datos del prospecto o usuario asignado')
      return
    }
    
    this.dialogEvaluacion = true
    this.evaluacionEditada = {}
    await this.obtenerPreguntasEvaluacion()
  },
  
  async obtenerPreguntasEvaluacion() {
    if (!this.chat || !this.chat.idprospectos || !this.chat.usuario_asignado) {
      
      this.preguntasEvaluacion = []
      return
    }
    
    
    
    try {
      const response = await this.$http.get(
        `twilio.get.preguntas/${this.chat.usuario_asignado}/${this.chat.idprospectos}`
      )
      
      this.preguntasEvaluacion = response.data || []
      
      // Inicializar evaluacionEditada con los valores existentes o false por defecto
      this.preguntasEvaluacion.forEach(pregunta => {
        if (pregunta.valor !== null) {
          this.evaluacionEditada[pregunta.id] = pregunta.valor === 1
        } else {
          this.evaluacionEditada[pregunta.id] = false
        }
      })
    } catch (error) {
      // Solo mostrar error si es un error real, no si simplemente no hay evaluación
      if (error.response && error.response.status !== 404) {
        console.error('Error al obtener preguntas:', error)
        // No mostrar error al usuario si es 404 (no hay evaluación aún)
      } else {
        console.log('No hay evaluación aún (404)')
      }
      this.preguntasEvaluacion = []
    }
  },
  
  async guardarEvaluacion() {
    if (!this.chat || !this.chat.idprospectos || !this.chat.usuario_asignado) {
      this.validarError('No se puede guardar: faltan datos del prospecto o usuario asignado')
      return
    }
    
    // Preparar los datos para enviar
    const respuestas = this.preguntasEvaluacion.map(pregunta => ({
      id: pregunta.id,
      valor: this.evaluacionEditada[pregunta.id] ? 1 : 0
    }))
    
    // Calcular el score
    const totalPreguntas = this.preguntasEvaluacion.length
    const preguntasTrue = respuestas.filter(r => r.valor === 1).length
    const score = (preguntasTrue / totalPreguntas) * 10 // Score de 0 a 10
    
    const payload = {
        idprospectos: this.chat.idprospectos,
        evaluado: this.chat.usuario_asignado,
        evaluador: this.getdatosUsuarioERPERP.iderp,
        respuestas: respuestas,
        score: score
      }

      
      
    this.cargar = true
    try {
      // Aquí debes usar el endpoint POST para guardar
      // Ajusta el endpoint según tu backend
      await this.$http.post('twilio.post.score', payload)
      
      this.validarSuccess('Evaluación guardada correctamente')
      this.dialogEvaluacion = false
      
      // Recargar las preguntas para actualizar el score
      await this.obtenerPreguntasEvaluacion()
    } catch (error) {
      this.validarError(error.response.data.message || 'Error al guardar evaluación')
    } finally {
      this.cargar = false
    }
  },
  
  puedeGuardarEvaluacion() {
    // Verificar que todas las preguntas tengan un valor asignado
    return this.preguntasEvaluacion.every(p => 
      this.evaluacionEditada[p.id] !== undefined && 
      this.evaluacionEditada[p.id] !== null
    )
  },

    abrirPegar(event) {
      //console.log(event)
    },

    abrirAjustesMensajes() {

      this.openDialogMensajes.estatus = true
    },

    processChats() {
      // Validar que this.allChats sea un array antes de procesarlo
      if (!Array.isArray(this.allChats)) {
        console.warn('processChats: this.allChats no es un array', this.allChats);
        this.allChats = []
        this.guardarConversacionesUnif(this.allChats)
        return;
      }


      // console.log( ' cambios ', this.allChats )

      this.conteoEtiquetas(this.allChats)

      this.setVendedorAsignado()

      this.allChats = ordenarChatsPorMasReciente(this.allChats)

      //console.log('Fueron ordenados');


      this.allChats = Object.values(
        this.allChats.reduce((acc, item) => {
          acc[item.usuario] = item
          return acc
        }, {})
      )

      this.allChats = ordenarChatsPorMasReciente(this.allChats).slice(0, 3000)
      this.actualizarConteoTiempoVendedores(this.allChats)

      this.guardarConversacionesUnif(this.allChats)

      this.$nextTick(() => this.tryAbrirChatExamenPendiente())
    },
    setVendedorAsignado() {
      // Validar que this.allChats sea un array antes de procesarlo
      if (!Array.isArray(this.allChats)) {
        console.warn('setVendedorAsignado: this.allChats no es un array', this.allChats);
        return;
      }

      if (this.vendedoras_plantel && this.vendedoras_plantel.length) {
        const ref = this;
        this.allChats.forEach(it => {
          const idUsuarioAsignado = Number(it.usuario_asignado)
          if (!idUsuarioAsignado) return
          const vendedor = ref.vendedoras_plantel.find(vp => Number(vp.iderp) === idUsuarioAsignado)
          if (vendedor) {
            it.vendedor = {
              ...vendedor,
              nombre: ref.formatearNombre(vendedor.nombre),
            }
          }
        })
      }
    },
    formatearNombre(nombreCompleto) {
      if (!nombreCompleto || typeof nombreCompleto !== 'string') {
        return '';
      }

      return nombreCompleto
        .trim()                          // quita espacios sobrantes al inicio y final
        .toLowerCase()                   // todo a minúsculas primero
        .split(/\s+/)                    // divide por uno o más espacios
        .map(palabra =>
          palabra.charAt(0).toUpperCase() + palabra.slice(1)
        )
        .join(' ');
    },
    onlyMyChats() {
      this.filtroVendedora = null

      this.initializeAllCities()
    },
    limpiarFiltrosLista() {
      const veniaCartera = !!this.filtroCartera
      this.filtroMensajes = false
      this.filtroHielo = false
      this.filtroRecomendados = false
      this.filtroFuego = false
      this.filtroCartera = false
      this.filtroFinalizo = false
      this.filtroAgenteIA = false
      this.filtroVistos = false
      this.etiqueta = null
      this.filtroTiempo = null
      this.filtroSinProspecto = null
      this.filtroIncompletos = null
      this.filtroCiudad = 'todas'

      const veniaUnaVendedora = !!(this.filtroVendedora && !this.filtroVendedora.esTodos)

      // Encargada: no borrar "Todas"; un vendedor normal vuelve a sus chats
      this._omitirWatchFiltroVendedora = true
      if (this.tieneEquipoCrm) {
        this.filtroVendedora = {
          iderp: null,
          id_usuario_asignado: null,
          nombre: 'Todos',
          esTodos: true,
        }
      } else {
        this.filtroVendedora = null
      }
      this._omitirWatchFiltroVendedora = false

      // Cartera o volver de una vendedora a Todos: recargar lista
      if (veniaCartera || veniaUnaVendedora) this.initializeAllCities()
    },
    activarFiltroFuego() {
      if (this.filtroFuego) {
        this.filtroFuego = false
        return
      }
      this.filtroFuego = true
      this.filtroHielo = false
      this.filtroCartera = false
      this.filtroFinalizo = false
      this.filtroAgenteIA = false
    },
    activarFiltroHielo() {
      if (this.filtroHielo) {
        this.filtroHielo = false
        return
      }
      this.filtroHielo = true
      this.filtroFuego = false
      this.filtroCartera = false
      this.filtroFinalizo = false
      this.filtroAgenteIA = false
    },
    activarFiltroRecomendados() {
      this.filtroRecomendados = !this.filtroRecomendados
    },
    activarFiltroMensajes() {
      this.filtroMensajes = !this.filtroMensajes
    },
    seleccionarEtiqueta(item) {
      if (this.etiqueta && this.etiqueta.idetiquetas == item.idetiquetas) {
        this.etiqueta = null
        return
      }
      this.etiqueta = item
    },
    onClickBotonEtiqueta() {
      if (this.etiqueta) this.etiqueta = null
    },
    onClickBotonTiempo() {
      if (this.filtroTiempo) this.filtroTiempo = null
    },
    seleccionarFiltroTiempo(item) {
      if (this.filtroTiempo && this.filtroTiempo.idtiempos == item.idtiempos) {
        this.filtroTiempo = null
        return
      }
      this.filtroTiempo = item
    },
    activarFiltroCartera() {
      // Toggle: si ya está activo, se apaga y recarga lista normal
      if (this.filtroCartera) {
        this.filtroCartera = false
        this.initializeAllCities()
        return
      }
      this.filtroCartera = true
      this.filtroFuego = false
      this.filtroHielo = false
      this.filtroFinalizo = false
      this.filtroAgenteIA = false
      this.filtroIncompletos = null
      this.filtroTiempo = null
      this.filtroMensajes = false
      this.filtroVistos = false
      this.etiqueta = null
      this.etapa = null
      // Recargar SOLO etiquetados de BD (no filtrar basura del store)
      this.initializeAllCities()
    },
    activarFiltroFinalizo() {
      if (!this.puedeVerFiltroFinalizo) return
      if (this.filtroFinalizo) {
        this.filtroFinalizo = false
        return
      }
      this.filtroFinalizo = true
      this.filtroFuego = false
      this.filtroHielo = false
      this.filtroCartera = false
      this.filtroAgenteIA = false
      this.filtroIncompletos = null
      this.filtroMensajes = false
      this.filtroVistos = false
      this.etiqueta = null
    },
    activarFiltroAgenteIA() {
      if (!this.puedeVerFiltroAgenteIA) return
      if (this.filtroAgenteIA) {
        this.filtroAgenteIA = false
        return
      }
      this.filtroAgenteIA = true
      this.filtroFuego = false
      this.filtroHielo = false
      this.filtroCartera = false
      this.filtroFinalizo = false
      this.filtroIncompletos = null
      this.filtroMensajes = false
      this.filtroVistos = false
      this.etiqueta = null
    },
    async getAllChats({ offset = 0 } = {}) {
      try {
        const payload = {
          idusuario: this.accesosBoton
            ? this.getdatosUsuarioERPERP.iderp
            : (this.filtroVendedora && !this.filtroVendedora.esTodos
              ? this.filtroVendedora.iderp
              : this.getdatosUsuarioERPERP.iderp),
          escuela: this.getEscuela,
          offset,
          // Temporal: pedir ~2k (admin default era 500 y la búsqueda no consultaba BD).
          limit: this.chatsLimitPedido,
          soloCartera: !!this.filtroCartera,
        }
        const t0 = offset === 0 ? performance.now() : null
        const response = await this.$http.post('twilio.chatsMCG', payload)
        if (t0 != null) {
          this.tiempoCargaMs = Math.round(performance.now() - t0)
        }
        const allChats = response.data.allChats

        if (!Array.isArray(allChats)) {
          console.warn('response.data.allChats no es un array', response.data)
          return []
        }

        if (this.filtroCartera && response.data.soloCartera !== true) {
          console.warn(
            '[cartera] La API no devolvió soloCartera=true. ¿Estás apuntando al api-rh local con el código nuevo?'
          )
          // No confiar en flags viejos: dejar solo los que traigan la marca
          return allChats.filter((el) => Number(el.cartera_fuego) === 1)
        }

        this.chatsPagination = response.data.pagination || {
          hasMore: false,
          offset,
          returned: allChats.length,
          limit: this.chatsLimitPedido,
        }

        return allChats
      } catch (error) {
        console.error(error)
        if (offset === 0) this.tiempoCargaMs = null
        return []
      }
    },
    async onCargarMasChats({ limiteVisible, total } = {}) {
      if (limiteVisible != null && total != null && limiteVisible < total) {
        this.limite = limiteVisible
        return
      }

      if (this.limite < this.filterChats.length) {
        this.limite += 50
        return
      }

      const pag = this.chatsPagination
      if (!pag || !pag.hasMore) return

      try {
        const nextOffset = (pag.offset || 0) + (pag.returned || 0)
        const page = await this.getAllChats({ offset: nextOffset })
        if (!page.length) return

        this.allChats = this.allChats.concat(page)
        this.processChats()
        this.limite += 50
      } catch (error) {
        console.error(error)
      }
    },
    async fetchChatsMcgPorUsuario(idusuario) {
      const payload = {
        idusuario,
        escuela: this.getEscuela,
        offset: 0,
        limit: this.chatsLimitPedido,
        soloCartera: !!this.filtroCartera,
      }
      const response = await this.$http.post('twilio.chatsMCG', payload)
      const data = (response && (response.data || response.body)) || {}
      const allChats = data.allChats
      return Array.isArray(allChats) ? allChats : []
    },

    async cargarChatsDeVendedora(idusuario) {
      this.cargar = true
      this.tiempoCargaMs = null
      this.allChats = []
      this.guardarConversacionesUnif([])
      try {
        const t0 = performance.now()
        const chats = await this.fetchChatsMcgPorUsuario(idusuario)
        this.tiempoCargaMs = Math.round(performance.now() - t0)
        this.allChats = chats
        this.chatsPagination = {
          hasMore: false,
          offset: 0,
          returned: chats.length,
          limit: this.chatsLimitPedido,
        }
        this.processChats()
        this.actualizarChatsEquipoSnapshot(this.allChats, idusuario)
      } catch (error) {
        console.error(error)
        this.allChats = []
        this.tiempoCargaMs = null
        this.guardarConversacionesUnif([])
      } finally {
        this.cargar = false
      }
    },

    async initializeAllCities(cambioEtiqueta) {
      if (!cambioEtiqueta) {
        this.mensajes = []
      }

      if (!this.vendedoras_plantel.length) {
        await this.getVendedoras()
      }

      // Encargada: Todos → equipo completo; una vendedora → su chatsMCG
      if (this.tieneEquipoCrm) {
        if (this.filtroVendedora && this.filtroVendedora.esTodos) {
          await this.getUsersChats()
          return
        }
        const id = this.idDeVendedora(this.filtroVendedora)
        if (id > 0) {
          await this.cargarChatsDeVendedora(id)
          return
        }
      }

      this.cargar = true
      this.tiempoCargaMs = null

      // Limpiar store antes de pedir (evita ver basura de una carga previa)
      this.allChats = []
      this.guardarConversacionesUnif([])

      const chats = await this.getAllChats()

      // Validar que chats sea un array antes de asignarlo
      if (Array.isArray(chats)) {
        this.allChats = chats
      } else {
        console.warn('getAllChats no devolvió un array', chats);
        this.allChats = []
      }

      this.cargar = false
      this.processChats()
      this.actualizarChatsEquipoSnapshot(this.allChats, this.idDeVendedora(this.filtroVendedora))
    },
    async getUsersChats() {
      this.cargar = true
      this.tiempoCargaMs = null
      this.allChats = []
      this.guardarConversacionesUnif([])
      try {
        const idusuarios = this.idsEquipoTwilio()
        if (!idusuarios.length) {
          this.allChats = []
          return
        }

        const t0 = performance.now()
        const pages = await Promise.all(
          idusuarios.map((idusuario) =>
            this.fetchChatsMcgPorUsuario(idusuario).catch(() => [])
          )
        )
        this.tiempoCargaMs = Math.round(performance.now() - t0)

        this.allChats = this.mergeChatsPorUsuario(pages)
        this.chatsPagination = {
          hasMore: false,
          offset: 0,
          returned: this.allChats.length,
          limit: this.chatsLimitPedido,
        }
        this.processChats()
        this.actualizarChatsEquipoSnapshot(this.allChats, null)
      } catch (error) {
        console.error(error)
        this.allChats = []
        this.tiempoCargaMs = null
        this.guardarConversacionesUnif([])
      } finally {
        this.cargar = false
      }
    },

    abrirDialogReiniciarContexto() {
      if (!this.chat) return
      this.modoLimpiarAgente = 'contexto'
      this.dialogLimpiarAgente = true
    },

    abrirDialogBorrarConversacion() {
      if (!this.chat) return
      this.modoLimpiarAgente = 'todo'
      this.dialogLimpiarAgente = true
    },

    async confirmarLimpiarAgente() {
      if (!this.chat || !this.chat.usuario) return
      this.limpiandoAgente = true
      try {
        const twilio = this.numeroTwilio || this.chat.numeroTwilio
        const res = await this.$http.post('twilio.agente.limpiar', {
          peer: this.chat.usuario,
          usuario: this.chat.usuario,
          twilio,
          modo: this.modoLimpiarAgente,
        })
        const payload = (res && res.body) || (res && res.data) || {}
        this.dialogLimpiarAgente = false

        if (this.modoLimpiarAgente === 'todo') {
          this.mensajes = []
          if (this.chat) {
            this.chat.mensaje = 'Sin mensajes'
            this.chat.sinleer = 0
          }
          this.validarSuccess(
            payload.message
              || `Conversación borrada (${payload.mensajes_eliminados || 0} msgs). Contexto reiniciado.`
          )
          if (typeof this.initializeAllCities === 'function') {
            await this.initializeAllCities()
          }
        } else {
          this.validarSuccess(payload.message || 'Contexto IA reiniciado. Mensajes conservados.')
        }
      } catch (error) {
        const msg = (error && error.body && error.body.message)
          || (error && error.response && error.response.data && error.response.data.message)
          || 'No se pudo limpiar'
        this.validarError(msg)
      } finally {
        this.limpiandoAgente = false
      }
    },

    async bloquearNumeroSpam() {
      if (!this.chat || !this.chat.usuario) {
        this.validarError('No hay chat seleccionado')
        return
      }
      const ok = window.confirm(
        `¿Bloquear ${this.chat.usuario} por spam?\n\nDejará de guardarse y procesarse cualquier mensaje de este número.`
      )
      if (!ok) return

      this.bloqueandoNumero = true
      try {
        const twilio = this.numeroTwilio || this.chat.numeroTwilio
        await this.$http.post('twilio.agente.bloquear', {
          usuario: this.chat.usuario,
          twilio,
          motivo: 'spam',
        })

        const usuarioBloqueado = this.chat.usuario
        let conversaciones = [...(this.getConversacionesUnif || this.allChats || [])]
        conversaciones = conversaciones.filter((c) => c.usuario !== usuarioBloqueado)
        this.allChats = conversaciones
        if (typeof this.guardarConversacionesUnif === 'function') {
          this.guardarConversacionesUnif(conversaciones)
        }
        this.chat = null
        this.mensajes = []
        this.validarSuccess('Número bloqueado. Ya no se procesarán sus mensajes.')
      } catch (error) {
        const msg = (error && error.response && error.response.data && error.response.data.message)
          || (error && error.message)
          || 'No se pudo bloquear el número'
        this.validarError(msg)
      } finally {
        this.bloqueandoNumero = false
      }
    },

    async cerrarContacto(){
      try {
        await this.$http.post('twilio.chat.cerrar.prospecto',{idprospectos:this.chat.idprospectos})
        this.chat = null
        this.initializeAllCities()
        
      } catch (error) {
        console.error(error);
      }
    },
    enriquecerProspectos(prospectos) {

      // 2. Enriquecer cada prospecto
      return prospectos.map(prospecto => {
        const plantel = prospecto.plantel ? prospecto.plantel.replace(/_/g, " ") : 'SIN PLANTEL'
        return {
          "idusuarios_wpp": 76481,
          "usuario": "whatsapp:+521" + prospecto.telefono,
          "nombre": "",
          "deleted": 0,
          "fecha_creacion": prospecto.fecha_creacion,
          "idetiquetas": 12,
          "ReferralSourceId": "",
          "ReferralSourceUrl": "",
          "ProfileName": prospecto.nombreCompleto,
          "ReferralHeadline": "",
          "ReferralCtwaClid": "",
          "ReferralBody": "",
          "mensaje": "El prospecto desea información",
          "mio": 1,
          "type": 1,
          "MediaUrl0": "",
          "color": "#E040FB",
          "totalMensajes": 0,
          "ventanaCerrada": 0,
          "diasSinMovimiento": 0,
          "tiemporestante": 0,
          "fecha_ultimo_mensaje": prospecto.fecha_creacion,
          "existe": true,
          "idprospectos": prospecto.idprospectos,
          "folio": prospecto.folio,
          "idetapa": prospecto.idetapa,
          "reasignado": 0,
          "city": plantel,
          "sucursal": true,
          "usuario_asignado": prospecto.usuario_asignado
        }
      })
    }
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/twilio-whatsapp-layout.scss';
.textoPoppins {
  font-family: 'Poppins', sans-serif !important;
  font-size: 14px;
  font-weight: 300;
}

#scroll-target::-webkit-scrollbar {
  -webkit-appearance: none !important;
}

#scroll-target::-webkit-scrollbar:vertical {
  width: 4px !important;
}

#scroll-target::-webkit-scrollbar-button:increment,
#scroll-target::-webkit-scrollbar-button {
  display: none;
}

#scroll-target::-webkit-scrollbar:horizontal {
  display: none;
}

#scroll-target::-webkit-scrollbar-thumb {
  background-color: #BABCBF;
  border-radius: 20px;
  border: 1px solid #ededed;
}

/*#mensajesChat{
    background-image: url("/fondo_whatsapp.jpg");
    background-repeat: repeat-y;
    background-repeat: repeat-x;
    background-size:contain;
  }
*/
#preguntas::-webkit-scrollbar {
  -webkit-appearance: none !important;
}

.v-data-table--fixed-header>#preguntas::-webkit-scrollbar:vertical {
  width: 4px !important;
}

#preguntas::-webkit-scrollbar:vertical {
  width: 4px !important;
}

#preguntas::-webkit-scrollbar-button:increment,
#preguntas::-webkit-scrollbar-button {
  display: none;
}

#preguntas::-webkit-scrollbar:horizontal {
  display: none;
}

#preguntas::-webkit-scrollbar-thumb {
  background-color: #BABCBF;
  border-radius: 20px;
  border: 1px solid #ededed;
}

/**********************************/

#mensajesChat::-webkit-scrollbar {
  -webkit-appearance: none !important;
}

.v-data-table--fixed-header>#mensajesChat::-webkit-scrollbar:vertical {
  width: 4px !important;
}

#mensajesChat::-webkit-scrollbar:vertical {
  width: 4px !important;
}

#mensajesChat::-webkit-scrollbar-button:increment,
#mensajesChat::-webkit-scrollbar-button {
  display: none;
}

#mensajesChat::-webkit-scrollbar:horizontal {
  display: none;
}

#mensajesChat::-webkit-scrollbar-thumb {
  background-color: #BABCBF;
  border-radius: 20px;
  border: 1px solid #ededed;
}

.container {
  padding: 0;
  background-color: #FFF;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  height: 750px;
  margin-top: 25px;
}

/* ===== MENU ===== */
.menu {
  float: left;
  height: 700px;
  ;
  width: 70px;
  background: #4768b5;
  background: -webkit-linear-gradient(#4768b5, #35488e);
  background: -o-linear-gradient(#4768b5, #35488e);
  background: -moz-linear-gradient(#4768b5, #35488e);
  background: linear-gradient(#4768b5, #35488e);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19);
}

.menu .items {
  list-style: none;
  margin: auto;
  padding: 0;
}

.menu .items .item {
  height: 70px;
  border-bottom: 1px solid #6780cc;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #9fb5ef;
  font-size: 17pt;
}

.menu .items .item-active {
  background-color: #5172c3;
  color: #FFF;
}

.menu .items .item:hover {
  cursor: pointer;
  background-color: #4f6ebd;
  color: #cfe5ff;
}

/* === CONVERSATIONS === */

.discussions {
  width: 100%;
  height: 702px;
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.20);
  overflow: hidden;
  display: inline-block;
}

.discussions .discussion {
  width: 100%;
  height: 90px;
  background-color: #FAFAFA;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.discussions .search {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #E0E0E0;
}

.discussions .search .searchbar {
  height: 40px;
  background-color: #FFF;
  width: 70%;
  padding: 0 20px;
  border-radius: 50px;
  border: 1px solid #EEEEEE;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.discussions .search .searchbar input {
  margin-left: 15px;
  height: 38px;
  width: 100%;
  border: none;
  font-family: 'Montserrat', sans-serif;
  ;
}

.discussions .search .searchbar *::-webkit-input-placeholder {
  color: #E0E0E0;
}

.discussions .search .searchbar input *:-moz-placeholder {
  color: #E0E0E0;
}

.discussions .search .searchbar input *::-moz-placeholder {
  color: #E0E0E0;
}

.discussions .search .searchbar input *:-ms-input-placeholder {
  color: #E0E0E0;
}

.discussions .message-active {
  height: 90px;
  background-color: #FFF;
  border-right: solid 5px #E91E63;
}

.discussions .discussion .photo {
  margin-left: 20px;
  display: block;
  width: 45px;
  height: 45px;
  background: #E6E7ED;
  /* -moz-border-radius: 50px;
    -webkit-border-radius: 50px; */
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.online {
  position: relative;
  top: 30px;
  left: 35px;
  width: 13px;
  height: 13px;
  background-color: #8BC34A;
  border-radius: 13px;
  border: 3px solid #FAFAFA;
}

.desc-contact {
  height: 43px;
  width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.discussions .discussion .name {
  margin: 0 0 0 20px;
  font-family: 'Montserrat', sans-serif;
  font-size: 11pt;
  color: #515151;
}

.discussions .discussion .message {
  margin: 6px 0 0 20px;
  font-family: 'Montserrat', sans-serif;
  font-size: 9pt;
  color: #515151;
}

.timer {
  margin-left: 15%;
  font-family: 'Open Sans', sans-serif;
  font-size: 11px;
  padding: 3px 8px;
  color: #BBB;
  background-color: #FFF;
  border: 1px solid #E5E5E5;
  border-radius: 15px;
}

.chat {
  width: calc(100%);
}

.chat .messages-chat {
  padding: 25px 10px;
}

.chat .messages-chat .message {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.chat .messages-chat .message .photo {
  display: block;
  width: 45px;
  height: 45px;
  background: #E6E7ED;
  /* -moz-border-radius: 50px;
    -webkit-border-radius: 50px; */
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.chat .messages-chat .text {
  margin: 0 35px;
  background-color: #f6f6f6;
  padding: 15px;
  border-radius: 12px;
}

.text-only {
  white-space: pre-line;
}

.time {
  font-size: 12px;
  color: lightgrey;
  margin-bottom: 10px;
  margin-left: 38px;
}

.response-time {
  float: right;
  margin-right: 40px !important;
}

.response {
  float: right;
  margin-right: 0px !important;
  margin-left: auto;
  /* flexbox alignment rule */
  max-width: 90%;
}

.noresponse {
  max-width: 90%;
}

.response .text {
  background-color: #E91E63 !important;
  color: white;
}

.footer-chat {
  width: calc(65% - 66px);
  height: 80px;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  background-color: transparent;
  border-top: 2px solid #EEE;

}

.chat .footer-chat .icon {
  margin-left: 30px;
  color: #C0C0C0;
  font-size: 14pt;
}

.chat .footer-chat .send {
  color: #fff;
  background-color: #4f6ebd;
  position: absolute;
  right: 50px;
  padding: 12px 12px 12px 12px;
  border-radius: 50px;
  font-size: 14pt;
}

.chat .footer-chat .name {
  margin: 0 0 0 20px;
  text-transform: uppercase;
  font-family: 'Montserrat', sans-serif;
  font-size: 13pt;
  color: #515151;
}

.chat .footer-chat .right {
  position: absolute;
  right: 40px;
}

/* Reset estilos legacy .container para el layout WhatsApp */
.twilio-whatsapp-shell.container {
  height: calc(100vh - 64px) !important;
  height: calc(100dvh - 64px - env(safe-area-inset-top, 0px)) !important;
  min-height: 0 !important;
  margin-top: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.twilio-whatsapp-shell #scroll-target.container,
.twilio-whatsapp-shell .wa-messages-scroll.container {
  height: 100% !important;
  min-height: 0 !important;
  margin-top: 0 !important;
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
